var ajax = new XMLHttpRequest();
ajax.open("get", "//www.seidoshop.com/cdn/shop/t/42/assets/site-js-locales.json?v=99423969116504100891710312205", true);
ajax.send();
ajax.addEventListener('load', function (e) {
  var translationJSon;
  translationJSon = JSON.parse(this.responseText);

  //get the current language
  var laLang = document.querySelector('[data-currency-primary]').getAttribute("lang");

(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
  /*\
  |*|
  |*|  :: cookies.js ::
  |*|
  |*|  A complete cookies reader/writer framework with full unicode support.
  |*|
  |*|  Revision #1 - September 4, 2014
  |*|
  |*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
  |*|  https://developer.mozilla.org/User:fusionchess
  |*|
  |*|  This framework is released under the GNU Public License, version 3 or later.
  |*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
  |*|
  |*|  Syntaxes:
  |*|
  |*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
  |*|  * docCookies.getItem(name)
  |*|  * docCookies.removeItem(name[, path[, domain]])
  |*|  * docCookies.hasItem(name)
  |*|  * docCookies.keys()
  |*|
  \*/

  var docCookies = {
    getItem: function (sKey) {
      if (!sKey) { return null; }
      return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
      var sExpires = "";
      if (vEnd) {
        switch (vEnd.constructor) {
          case Number:
            sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;
          case String:
            sExpires = "; expires=" + vEnd;
            break;
          case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
            break;
        }
      }
      document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
      return true;
    },
    removeItem: function (sKey, sPath, sDomain) {
      if (!this.hasItem(sKey)) { return false; }
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
      return true;
    },
    hasItem: function (sKey) {
      if (!sKey) { return false; }
      return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    },
    keys: function () {
      var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
      for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
      return aKeys;
    }
  };

  module.exports = docCookies;
  },{}],2:[function(require,module,exports){
  var Eventer = function (caller) {
    this.caller = caller;
    this.caller._events = {};
    this.caller.on = this.on;
    this.caller.off = this.off;
    this.caller.trigger = this.trigger;
  };

  // this === caller not Eventer
  Eventer.prototype.on = function (event, callback) {
    if (!this._events[event]) this._events[event] = [];
    this._events[event].push(callback);
    return this._events[event].length - 1;
  };

  Eventer.prototype.off = function (event, id) {
    if (event && id) {
      if (this._events[event][id]) this._events[event][id] = null;
    } else if (event) {
      if (this._events[event]) this._events[event] = null;
    } else {
      this._events = {};
    }
  };

  Eventer.prototype.trigger = function (event, args) {
    if (typeof args !== 'object') args = [args];
    for (var i in this._events[event]) {
      var e = this._events[event][i];
      if (this._events[event].hasOwnProperty(i) && typeof e === 'function') e.apply(this, args);
    }
  };

  module.exports = Eventer;
  },{}],3:[function(require,module,exports){
  module.exports = {
    /*
      Array Functions
    */
    // For each item in Array
    each: function (arr, callback, ctx) {
      for (var i = 0; i < arr.length; i++) {
        ctx = ctx || arr[i];
        callback.apply(ctx, [arr[i], i]);
      }
    },

    // For each item in Object
    eachIn: function (obj, callback, ctx) {
      for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
          ctx = ctx || obj[k];
          callback.apply(ctx, [obj[k], k]);
        }
      }
    },

    // Return true if item is in Array
    inArray: function (needle, haystack) {
      var found = false;
      this.each(haystack, function (hay) {
        if (needle === hay) found = true;
      });
      return found;
    },

    // return the last item in the array
    last: function (arr) {
      return arr[arr.length - 1];
    },


    /*
      String Functions
    */
    // Captialse the first char in String
    capitalise: function (str) {
      return str[0].toUpperCase() + str.slice(1);
    },


    /*
      Event Functions
    */
    // Run code when the page is ready
    ready: function (callback, ctx) {
      if (typeof callback !== 'function') return;

      if (document.readyState !== 'loading') {
        callback.apply(ctx);
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          callback.apply(ctx);
        });
      }
    },

    // CUSTOM FUNC for seido to trigger things when the core is ready
    readyCore: function (callback, ctx) {
      if (typeof callback !== 'function') return;

      if (window.SeidoCore.ready) {
        callback.apply(ctx);
      } else {
        window.SeidoCore.on('ready', function () {
          callback.apply(ctx);
        });
      }
    },

    // CUSTOM FUNC for seido to trigger things when the product is ready
    readyProduct: function (callback, ctx) {
      if (typeof callback !== 'function') return;

      if (window.ProductCore.ready) {
        callback.apply(ctx);
      } else {
        window.ProductCore.on('ready', function () {
          callback.apply(ctx);
        });
      }
    },

    // Make thing not happen until finished?
    // i.e. don't act on every window resize event, just the last one when we need it.
    debounce: function (callback, wait, ctx) {
      var timeout, timestamp, args;
      wait = wait || 100;

      var later = function() {
        var last = new Date().getTime() - timestamp;
        if (last < wait && last >= 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          callback.apply(ctx, args);
        }
      };

      return function () {
        ctx = ctx || this;
        args = arguments;
        timestamp = new Date().getTime();
        if (!timeout) timeout = setTimeout(later, wait);
      };
    },

    // Don't swamp us with events
    // good for things like scroll and resize
    throttle: function (callback, limit, ctx) {
      limit = limit || 200;
      var wait = false;
      return function () {
        if (!wait) {
          callback.apply(ctx, arguments);
          wait = true;
          setTimeout(function () {
            wait = false;
          }, limit);
        }
      }
    },

    // Get the value of a url parameter
    getUrlParameter: function (sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    },

    // Convenience function to add the money span markup.
    moneying: function(price){
      // if("USD CAD EUR GBP AUD CHF HKD NZD SGD KRW RUB" != '')
      //   var newPrice =  Currency.formatMoney(price,Currency.moneyFormats[CoreInit.ShopCurrency]["money_with_currency_format"]);
      // else
      //   var newPrice =  "&#165;" + ((price/100).toLocaleString('ja-JP', {  currency: 'JPY' }));
      // return '<span class="money" data-currency-'+CoreInit.ShopCurrency.toLowerCase()+'="'+newPrice+'">'+newPrice+'</span>';
      var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");
            var daPrice =  Currency.formatMoneyUpdateCart(price,Currency.moneyFormats[currentCurrency]["money_with_currency_format"]);

        return '<span data-currency-'+currentCurrency+'="'+daPrice+'">'+daPrice+'</span>';
    },

    // Get height of element (with padding and marging)
    outerHeight: function(el){
      var height = el.offsetHeight;
      var style = getComputedStyle(el);
      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
      return height;
    },

    //
    smoothScroll: function(target){
      var yPosition = - window.getComputedStyle(target, null).marginTop.replace("px", "");
      while(target) {
        // yPosition += (target.offsetTop - window.getComputedStyle(target, null).marginTop.replace("px", ""));
        yPosition += target.offsetTop;
        target = target.offsetParent;
      }
      var windowSize = window.getComputedStyle(document.body,':after').getPropertyValue('content').replace(/['"]/g, '');
      //In XS the header is already fixed and in SM no header
      //In the other cases when the header is fixed the logo height is 0 or the difference after scrolling is around 65px
      // yPosition -= (windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0) ? parseInt(document.querySelector(".site-header-menu").offsetHeight):
      //              windowSize == "sm" ? 0 :
      //              "english" == "japanese" ? 180: 170;
      yPosition -= (windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0) ? parseInt(document.querySelector(".site-header-menu").offsetHeight):
                   windowSize == "sm" ? 0 :
                   window.location.href.indexOf("/ja") != -1 ? 180: 170;
                   //if (window.location.href.indexOf("/ja") != -1)
      $('.offcanvas-main').animate({
        scrollTop: yPosition
      }, 1000);
    },

    uniqueArray: function(arr){
      var n = {},r=[];
      for(var i=0; i<arr.length;i++){
        if (!n[arr[i]]){
          n[arr[i]] = true;
          r.push(arr[i]);
        }
      }
      return r;
    }
  };

  },{}],4:[function(require,module,exports){
  /* Paid shipping countries */

  var zone_l = ["Chile", "Djibouti", "Ecuador", "Ghana", "Paraguay", "Uruguay"];
  var zone_m = ["Bolivia", "Falkland Islands (Malvinas)", "Angola", "Chad", "Comoros", "Equatorial Guinea", "Gambia", "Guinea", "Guinea Bissau", "Lesotho", "Liberia", "Malawi", "Mali", "Mauritania", "Mozambique", "Namibia", "Benin", "Burkina Faso", "Burundi", "Cape Verde", "Republic of Cameroon", "Sao Tome And Principe", "Suriname", "Swaziland", "Zambia"];
  var zone_n = ["Algeria", "Botswana", "Côte d'Ivoire", "Ethiopia", "Gabon", "Kenya", "Madagascar", "Reunion", "Rwanda", "Senegal", "Sierra Leone", "Tanzania, United Republic Of", "Togo", "Uganda", "Zimbabwe", "Mauritius", "Morocco", "Nigeria", "South Africa"];
  var zone_p = ["Venezuela", "Peru", "Argentina", "Colombia", "Egypt", "Tunisia"];
  var zone_q = ["Central African Republic", "Congo", "Congo, The Democratic Republic Of The", "Eritrea", "Faroe Islands", "Nauru", "Saint Helena", "Somalia", "Tuvalu", "Wallis And Futuna", "Yemen", "South Sudan", "Sudan", "Seychelles", "Niger"];
  var zone_s = ["Aland Islands", "St. Vincent", "Turks and Caicos Islands"];
  var zone_u = ["French Polynesia", "Bahamas", "Belize", "Bermuda", "Cayman Islands", "Dominica", "Dominican Republic", "Georgia", "Grenada", "Guatemala", "Guyana", "Moldova, Republic of", "Montenegro", "Montserrat", "Aruba", "French Guiana"];
  var zone_w = ["Curaçao", "Anguilla", "Antigua And Barbuda", "Haiti", "Netherlands Antilles", "Nicaragua", "Saint Barthélemy", "Saint Lucia", "Saint Martin", "Sint Maarten"];


  var PaidShipping = {
    zones: [zone_l,zone_m,zone_n,zone_p,zone_q,zone_s, zone_u, zone_w],
    countries: zone_l.concat(zone_m,zone_n,zone_p,zone_q,zone_s, zone_u, zone_w)
  };

  module.exports = PaidShipping;

  },{}],5:[function(require,module,exports){
  var _ = require('./_lib.js');

  var ProductNav = function(){
    this.navElements = document.getElementsByClassName('quick-nav-link');
    this.arrayDomElements = [];
    this.logoWrapper = document.querySelector('.site-logo-wrapper');
    this.headerMenu = document.querySelector(".site-header-menu");
    this.wrapper = document.querySelector('.offcanvas-main');
    this.init();
  };

  ProductNav.prototype.init = function(){
    var _this = this;
    _.each(this.navElements, function(nav_link){
      _this.arrayDomElements.push([nav_link,document.querySelector(nav_link.dataset.scroll)]);
    });
    this._addEventListeners();
  };

  ProductNav.prototype._addEventListeners = function(){
    var _this = this;
    this.tabSwitcher();
    this.wrapper.addEventListener('scroll', _.debounce(function () {
      _this.setActiveElement();
    }));
  };


  ProductNav.prototype.tabSwitcher = function(){
    var _this = this;
    _.each(this.navElements, function(nav_link){
      var regex = /tab\w+/g;
      var tab_name = nav_link.className.match(regex);
      if(tab_name){
        var action_tab = document.getElementById('action-'+tab_name);
        if(action_tab){
          action_tab.addEventListener('click', function(){
          _.each(_this.navElements, function(link){
            if(nav_link == link){
              link.dataset.state = "active";
            }
            else{
              link.dataset.state = "";
            }
          });
          });
          nav_link.addEventListener('click',function(){
            var event = document.createEvent('HTMLEvents');
            event.initEvent('click', false, false);
            action_tab.dispatchEvent(event);
          });
        }
      }
    });
  };


  ProductNav.prototype.setActiveElement = function(){
    var index_active = 0;
    var regex = /tab\w+/g;
    var windowSize = window.getComputedStyle(document.body,':after').getPropertyValue('content').replace(/['"]/g, '');
    // var header_height = (windowSize == "xs" || this.logoWrapper.offsetHeight == 0) ? parseInt(this.headerMenu.offsetHeight):
    //           windowSize == "sm" ? 0 :
    //                 "english" == "japanese" ? 180: 170;
    var header_height = (windowSize == "xs" || this.logoWrapper.offsetHeight == 0) ? parseInt(this.headerMenu.offsetHeight):
                  windowSize == "sm" ? 0 :
                        window.location.href.indexOf("/ja") != -1 ? 180: 170;

    for(var i=0;i<this.arrayDomElements.length;i++){
      this.arrayDomElements[i][0].dataset.state = "";
      if(this._getPosition(this.arrayDomElements[i][1]) < 2*header_height){
      var tab_name = this.arrayDomElements[i][0].className.match(regex);
      if(tab_name){
        var action_tab = document.getElementById('action-'+tab_name);
        if(action_tab && action_tab.classList.contains('is-active')){
          index_active = i;
        }
      }
      else{
        index_active = i;
      }
    }
    }
    if(this.arrayDomElements.length){
      this.arrayDomElements[index_active][0].dataset.state = "active";
    }
  };

  ProductNav.prototype._getPosition = function (element) {
    var yPosition = 0;//element.offsetHeight;
    while(element) {
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }
    return yPosition;
  };

  module.exports = ProductNav;
  },{"./_lib.js":3}],6:[function(require,module,exports){
  var _ = require('./_lib.js');
  var cookies = require('./_cookies.js');
  var ShippingDate = require('./_shipping-date.js');
  var PaidShipping = require('./_paid-shipping.js');

  // var urlBase;
  // if(document.querySelector("html[lang]").getAttribute("lang") == "en"){
  //   urlBase = "/cart";
  // }else{
  //   urlBase = "/"+document.querySelector("html[lang]").getAttribute("lang")+"/cart";
  // }

  var ProductProcessing = function(selector) {
    this.selector = selector;
    this.selector.getVariantById = this.getVariantById;
    this.selector.selectCallback = this.selectCallback;
    this.ShippingDate = new ShippingDate();
    this.hasRecap = document.getElementById('setRecap') ? true:false;

    this.init();
  };


  ProductProcessing.prototype.init = function(){
    var _this = this;
    this.setInitValues();
    this.setUpdateCartTotal();
    this._addEventListeners();
    this.setConditionalOption();
    this.rearrangeOptions();
    //handle sold out modal and display
    this.handleInfosModal(0);
    this.handleSoldOutPrint(0);
    this.handleModalTooMuchItem();
  }

  ProductProcessing.prototype.setInitValues = function() {
    var _this = this;
    var qty = _.getUrlParameter("quantity");
    if(qty!=undefined){
      var quantity = document.getElementById("quantity");
      quantity.value = qty;
      if(this.hasRecap){
        var quantityRecap = document.getElementById("quantityRecap");
        quantityRecap.value = qty;
      }
    }

    if(_.getUrlParameter('product_reviews')=='true') {
      var review_action = document.getElementById('action-tabReviews');
      if(review_action){
        var event = document.createEvent('HTMLEvents');
        event.initEvent('click', false, false);
        setTimeout(function () {
          review_action.dispatchEvent(event);
        }, 1500);
      }
    }
  };


  ProductProcessing.prototype.setUpdateCartTotal = function(){
    var _this = this;
    var addBtns = document.querySelectorAll(".product-add-to-cart");
    var lastClick = null;
    _.each(addBtns, function (addBtn) {
    addBtn.addEventListener('click', function (e) {
      e.target.innerHTML = '<svg style="width:2.5em" class="icon icon-dots icon-inline"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-dots"></use></svg>';
      if (lastClick ==  null || Date.now() - lastClick > 4000) {
        lastClick = Date.now();
        _this.updateCartTotal();
      }
    });
  });
  }

  ProductProcessing.prototype._addEventListeners = function() {
    var _this = this;
      var selectMetric = document.getElementById("metrics");
      selectMetric.addEventListener('change', function () {
        var options = document.querySelectorAll("option[data-imperial]");
        if(this.value =="imperial"){
          _.each(options, function(option){
            option.innerHTML = option.innerHTML.replace(option.value,option.dataset.imperial);
          });
        }else{
          _.each(options, function(option){
            option.innerHTML = option.innerHTML.replace(option.dataset.imperial,option.value);
          });
        }

      });

      if(cookies.hasItem("cookieCountry")){
        var country_value = cookies.getItem("cookieCountry");
        _this.setInfoShipping(country_value);
      }
      // var countrySelector = document.getElementById('sidebar-tools-country');
      var countrySelector = document.getElementById('country_selector');
      countrySelector.addEventListener("change",function(){
        _this.setInfoShipping(this.value);
      });

    var requiredEles = document.querySelectorAll(".template-content [required]")
    _.each(requiredEles, function(elt){
      if(elt.tagName=="INPUT"){
        elt.addEventListener('input', function(event) {
            _this.selectCallback();
        });
      }
      else{
        elt.addEventListener('change', function () {
          _this.selectCallback();
        });
        elt.addEventListener('keypress', function(event) {if (event.keyCode == 13) {return false;}});
      }
    });

    var deleteUploadImages = document.querySelectorAll(".fileDeletebutton");
    _.each(deleteUploadImages, function(btn){
      btn.addEventListener('click', function () {
        var inputContent = document.querySelector("[id$='"+btn.dataset.uploadedImage.replace("Uploaded_Image","_Content")+"']");

        document.getElementById(btn.dataset.uploadedImage).value = "";
        inputContent.setAttribute("required","");
        $(this).parents('.uploadFileWrapper').removeClass('uploadFileWrapper-uploaded');
        var event = document.createEvent('HTMLEvents');
        event.initEvent('change', true, false);
        inputContent.dispatchEvent(event);
        _this.selectCallback();
        return false;
      });
    });

    var inputImages = document.querySelectorAll('[type="file"]');
    _.each(inputImages, function(btn){
        var inputContent = document.querySelector("[id$='"+btn.id.replace("Uploaded_Image","_Content")+"']");
        btn.addEventListener('change', function () {
        if (this.value && this.value !== ""){
          inputContent.removeAttribute("required");
          $(this).parents('.uploadFileWrapper').addClass('uploadFileWrapper-uploaded');
        }
        else{
         inputContent.setAttribute("required","");
        }
        var event = document.createEvent('HTMLEvents');
        event.initEvent('change', true, false);
        inputContent.dispatchEvent(event);
        _this.selectCallback();
      });
    });

    var review_link = document.querySelector("a.tabReviews[data-scroll='#product-descriptions-anchor']");
    var review_action = document.getElementById('action-tabReviews');
    if(review_link && review_action){
      review_link.addEventListener('click',function(){
        var event = document.createEvent('HTMLEvents');
        event.initEvent('click', false, false);
        review_action.dispatchEvent(event);
      });
    }

    if(this.hasRecap){
      var btnError = document.getElementById("btn-jump-error");
      btnError.addEventListener('click', function(){
        var forms = document.querySelectorAll("[name='add-item-form'][form-disabled='false']");
        for(i=0;i<forms.length;i++){
          var p = ProductsData.products[forms[i].getAttribute('id').replace("add-form-", "")];
          var v = _this.getVariantById(p,forms[i].elements["id"].value);
          if(v==null || !_this._checkRequired(forms[i]) || !v.available){
            // Open the collection of services if needed
            var coll_service = forms[i].closest('.service');
            if(coll_service){
              var coll_service_header = coll_service.querySelector('.service-header');
              if(coll_service_header && coll_service_header.dataset.state == 'hidden'){
                var event = document.createEvent('HTMLEvents');
                event.initEvent('click', false, false);
                coll_service_header.dispatchEvent(event);
              }
            }
            // Open the service if needed
            var header_toggle = document.querySelector('[data-display-toggle="#service-'+p.handle+'"]');
            if(header_toggle && header_toggle.dataset.state == 'hidden'){
              var event = document.createEvent('HTMLEvents');
              event.initEvent('click', false, false);
              header_toggle.dispatchEvent(event);
            }
            _.smoothScroll(forms[i]);
            break;
          }
        };
      });
    }

    var quantity = document.getElementById("quantity");
    var quantityRecap = document.getElementById("quantityRecap");
    if(quantity && quantityRecap){
      quantity.addEventListener('change', function(){
            quantityRecap.value = quantity.value;
            _this.selectCallback();
            var variant =  _this.getVariantById(ProductsData.products[meta.product.id],$("#product-select-"+meta.product.id).val());
            _this.compareQtyStock(meta.product.id, variant.id);
      });
      quantityRecap.addEventListener('change', function(){
            quantity.value = quantityRecap.value;
            _this.selectCallback();
            var variant =  _this.getVariantById(ProductsData.products[meta.product.id],$("#product-select-"+meta.product.id).val());
            if(variant){
              _this.compareQtyStock(meta.product.id, variant.id);
            }
      });
    }

    //add listener on cart window, when changing product quantity. Needed to manage the stock and activate or not the add to cart button
    var cart_items = document.querySelectorAll('.cart-item input');
    _.each(cart_items, function(cart_item){
        cart_item.addEventListener('change', function () {
          //delay this event. Need to compare the stock after the event in the cart is over.
          //The event in the cart change the value of the input again if the value is superior to the quantity in stock
          setTimeout(function(){
            var variant =  _this.getVariantById(ProductsData.products[meta.product.id],$("#product-select-"+meta.product.id).val());
            if(variant){
              _this.compareQtyStock(meta.product.id, variant.id);
            }
          },500);
      });
    });

  };//fin addEventListeners


  ProductProcessing.prototype.compareQtyStock = function(product_id, variant_id){
    var _this = this;
    var quantity = document.getElementById("quantity");
    var prodData = ProductsData.products[meta.product.id];
    var variant =  _this.getVariantById(prodData,$("#product-select-"+meta.product.id).val());

    var variant_is_diff = false;
    if(variant && _this.chosen_variant_compare != variant.id){
      variant_is_diff = true;
    }

    //if manage the stock for this variant, we change the button depending of the value inside the quantity
    var qty_product_in_cart=0;
    //reset by default before changing - since function is called after each select change, it allow to keep the original behavior intact
    var is_other_product = false;
    $(".button-add-to-cart-disclaimer-content").removeClass("display_none");
    $(".button-add-to-cart-disclaimer-content.tooltipQtySuperior").addClass("display_none");
    if(variant && variant.inventory_management){

      //if no special sku, search if the sku exist in the cart. if it does, take the value - also search if it exist in a set and add the quantity of the set
      if(variant.sku.indexOf("-") == -1 && variant.sku.indexOf("/") == -1 && variant.sku.indexOf("!") == -1){

        cart_products_sku_val = jQuery.map(Object.keys(CartProductsData.products), function(val, i) {
          if (val.indexOf("-sku") != -1) {
            return {"sku":CartProductsData.products[val], "val": val};
          }
        });
        for(var k=0; k<cart_products_sku_val.length; k++){
          var current_cart_product = cart_products_sku_val[k];
          //compare the sku and the one of the product
          //compare with split -, normally does not exist, but prevent the case anyway
          if(current_cart_product.sku.indexOf("-") == -1 && current_cart_product.sku.indexOf("/") == -1 && current_cart_product.sku.indexOf("!") == -1 && current_cart_product.sku.split("-")[0] == variant.sku){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
            }
          }
          else if(current_cart_product.sku.indexOf("/") != -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              var sku_array = current_cart_product.sku.split("/");
              for(var s=0; s<sku_array.length; s++){
                if(sku_array[s].split("-")[0] == variant.sku.split("-")[0]){
                  qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
                }
              }
            }
          }
          //for special set, composing of multiple the same item (!2 = 2 of this item)
          else if(current_cart_product.sku.indexOf("!") != -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              var single_sku = current_cart_product.sku.split("!");
              if(single_sku[0] == variant.sku){
                qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value * single_sku[1]);
              }
            }
          }
        }
      }

      //if variant sku contains '-' (is a variant which shared same stock with others)
      //search in the cart if there is a variant with the same sku root (the sku before the -)
      else if(variant.sku.indexOf("-") != -1 && variant.sku.indexOf("/") == -1 && variant.sku.indexOf("!") == -1){
        cart_products_sku_val = jQuery.map(Object.keys(CartProductsData.products), function(val, i) {
          if (val.indexOf("-sku") != -1) {
            return {"sku":CartProductsData.products[val], "val": val};
          }
        });
        for(var k=0; k<cart_products_sku_val.length; k++){
          var current_cart_product = cart_products_sku_val[k];
          //if required_keys is not a set
          var vid = current_cart_product.val.split("-")[0];
          if(current_cart_product.sku.split("-")[0] == variant.sku.split("-")[0] && current_cart_product.sku.indexOf("/") == -1 && current_cart_product.sku.indexOf("!") == -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
                qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
            }
          }

          //if required_keys is a set
          //need to check if in the cart, there is a set which contains a variant with the same sku root
          else if(current_cart_product.sku.indexOf("/") != -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']")
            for(var x=0; x<allSameSku.length;x++){
              var sku_array = current_cart_product.sku.split("/");
              for(var s=0; s<sku_array.length; s++){
                if(sku_array[s].indexOf("-") != -1 && sku_array[s].split("-")[0] == variant.sku.split("-")[0]){
                  qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
                }
              }
            }
          }
          //for special set, composing of multiple the same item (!2 = 2 of this item)
          else if(current_cart_product.sku.indexOf("!") != -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              var single_sku = current_cart_product.sku.split("!");
              //check if same root sku
              if(single_sku[0].split("-")[0] == variant.sku.split("-")[0]){
                qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value * single_sku[1]);
              }
            }
          }
        }
      }

      //if variant contains "!" : it's a special set :
      //can't have both set and !, but prevent that
      else if(variant.sku.indexOf("!") != -1 && variant.sku.indexOf("/") == -1){
        cart_products_sku_val = jQuery.map(Object.keys(CartProductsData.products), function(val, i) {
          if (val.indexOf("-sku") != -1) {
            return {"sku":CartProductsData.products[val], "val": val};
          }
        });
        for(var k=0; k<cart_products_sku_val.length; k++){
          var current_cart_product = cart_products_sku_val[k];
          //if required key is like XXXX!Y (can be itself)
          // var vid = required_keys[k].val.split("-")[0];
          if(current_cart_product.sku.indexOf("!") != -1){
            var single_sku = current_cart_product.sku.split("!");
            if(single_sku[0].split("-")[0] == variant.sku.split("!")[0] || single_sku[0].split("-")[0] == variant.sku.split("-")[0]){
              var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
              for(var x=0; x<allSameSku.length;x++){
                qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value * single_sku[1]);
              }
            }
          }
          //if required_keys sku is like XXXX or XXXX-1
          else if((current_cart_product.sku.split("-")[0] == variant.sku.split("!")[0] || current_cart_product.sku.split("-")[0] == variant.sku.split("-")[0]) && current_cart_product.sku.indexOf("/") == -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
            }
            // qty_product_in_cart += parseInt($( ".cart-item[data-line-id^='"+vid+"'] input" ).val());
          }
          //if required_keys sku is like XXXX/YYYY/ZZZZ
          else if(current_cart_product.sku.indexOf("/") != -1){
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              var sku_array = current_cart_product.sku.split("/");
              for(var s=0; s<sku_array.length; s++){
                if(sku_array[s].indexOf("-") != -1 && sku_array[s].split("-")[0] == variant.sku.split("-")[0]){
                  qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
                }
              }
            }
          }
        }
      }

      //if variant sku contains '/' (is a set), check if element in the cart got a sku contain in the set
      //also, check if for this sku we manage the inventory. if not, we ignore it
      else if(variant.sku.indexOf("/") != -1){
        cart_products_sku_val = jQuery.map(Object.keys(CartProductsData.products), function(val, i) {
          if (val.indexOf("-sku") != -1) {
            return {"sku":CartProductsData.products[val], "val": val};
          }
        });
        // only for the sets. Need only to add the quantity of the set itself, and the maximum of one of the items of the set in the cart
        // var max_qty=0;
        // Need this to separate each item of the set and to compute all the quantity of each item in the cart
        // the format is => {"root_sku": total qty} (of that item in the cart)
        var item_set_qty_in_cart = {};
        var sku_group = {};
        for(var k=0; k<cart_products_sku_val.length; k++){
          var current_cart_product = cart_products_sku_val[k];
          //required_keys contains the sku of the variant
          //soit prend en compte toutes les variantes (donc un sku qui appartient à ce set)
          if(!document.querySelector( ".cart-item[data-line-sku='"+current_cart_product.sku+"']")){
            //ignore if it's a service
            //only for set - because only case when we need the qty of other products
            continue;
          }
          //loop through all variant of the set and find an item corresponding to it
          var manage_qty = document.querySelector( ".cart-item[data-line-sku='"+current_cart_product.sku+"']").getAttribute("data-line-inventory-quantity");

          if(variant.sku == current_cart_product.sku){
            //add ALL occurences of this sku in the cart
            var allSameSku = $(".cart-item[data-line-sku='"+current_cart_product.sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              qty_product_in_cart += parseInt(allSameSku[x].querySelector("input").value);
            }
          } else if(current_cart_product.sku.indexOf("/") != -1){
            var array_current_sku = current_cart_product.sku.split("/");
            for(var splitsku=0; splitsku<array_current_sku.length; splitsku++){
              var updated_values =  this.buildQtyForSet(variant.sku, array_current_sku[splitsku], item_set_qty_in_cart, sku_group, manage_qty, current_cart_product.sku);
              item_set_qty_in_cart = updated_values[0];
              sku_group = updated_values[1];
            }
          }else{
            var updated_values = this.buildQtyForSet(variant.sku, current_cart_product.sku, item_set_qty_in_cart, sku_group, manage_qty, null);
            item_set_qty_in_cart = updated_values[0];
            sku_group = updated_values[1];
          }
        }

        //if the quantity of the set selected is inferior to the quantity of the set in stock, we go through the sku of the set and check if there is any single sku whose quantity is superior to the quantity in stock for that sku
        var inventory_is_deny=false;
        var the_sku_too_much="";
        if(qty_product_in_cart + parseInt(quantity.value) <= variant.inventory_quantity){
          Object.keys(item_set_qty_in_cart).forEach (function (sku) {
            var total = parseInt(item_set_qty_in_cart[sku]) + qty_product_in_cart + parseInt(quantity.value);
            //get an array of these sku
            var arr_sku = sku_group[sku].split(",");
            var inventory_qty_other_product=0;
            for(var s=0; s<arr_sku.length; s++){
              if(arr_sku.length >1 && arr_sku[s].indexOf("!") != -1){
                //skip if sku contains "!" if possible
                continue;
              }
              //don't take set into account, need quantity of the single sku, not another set
              if(arr_sku[s].indexOf("!") == -1 && arr_sku[s].indexOf("/") == -1){
                inventory_qty_other_product = parseInt(document.querySelector("tr[data-line-sku='"+arr_sku[s]+"'").getAttribute("data-line-inventory-quantity"));
              }else if(arr_sku[s].indexOf("/") == -1){
                //contains "!"
                var amount_per_set = parseInt(arr_sku[s].split(",")[1]);
                inventory_qty_other_product = parseInt(document.querySelector("tr[data-line-sku='"+arr_sku[s]+"'").getAttribute("data-line-inventory-quantity")) * amount_per_set;
              }else{
                //if cart contains only sets, get qty max
                var qty = parseInt(document.querySelector("tr[data-line-sku='"+arr_sku[s]+"'").getAttribute("data-line-inventory-quantity"));
                if( qty > inventory_qty_other_product && qty >= variant.inventory_quantity ){
                  inventory_qty_other_product = parseInt(document.querySelector("tr[data-line-sku='"+arr_sku[s]+"'").getAttribute("data-line-inventory-quantity"));
                }
              }
            }

            //if no other set, set the qty to the inventory quantity of the variant
            if(inventory_qty_other_product == 0){
              inventory_qty_other_product = variant.inventory_quantity;
            }

            if(total > inventory_qty_other_product  && !inventory_is_deny){
              //si set + qty du sku > quantity du sku dispo en stock
              // other_product_info = {"qty_product":Math.ceil(total), "sku_list":sku_group[sku], "is_other_product":true};
              is_other_product = true;
              //in case it does not pass the following if
              the_sku_too_much = arr_sku[0];
              if(document.querySelector("tr[data-line-sku='"+arr_sku[0]+"'").getAttribute("data-line-inventory-policy") == "deny"){
                the_sku_too_much = arr_sku[0];
                inventory_is_deny = true;
              }
            }
          });
        }
      }

      if(!is_other_product){
        //do something about the total_quantity if variant got a "!" if(variant.sku.indexOf("!") != -1)
        //divide total by two, and take the bottom integer value if the total quantity is odd
        // keep the quantity if the value of total_quantity is even
        if(variant.sku.indexOf("!") != -1){
          var corrected_quantity_in_cart = Math.ceil(parseInt(qty_product_in_cart) / parseInt(variant.sku.split("!")[1]));
          var total_quantity = parseInt(quantity.value) + corrected_quantity_in_cart;
        }else{
          //if quantity wanted superior to stock, disable the button (and print a message ?)
          var total_quantity = parseInt(quantity.value) + parseInt(qty_product_in_cart);
        }

        if((total_quantity > parseInt(variant.inventory_quantity)) && variant.inventory_policy == "deny"){
          $(".product-add-to-cart").addClass("disabled").attr("disabled", true);
          //show the tooltip saying the quantity is superior to the stock ?
          if(parseInt(variant.inventory_quantity) != 0 ){
            $(".button-add-to-cart-disclaimer-content").addClass("display_none");
            $(".button-add-to-cart-disclaimer-content.tooltipQtySuperior").removeClass("display_none");

            if(parseInt(variant.inventory_quantity) > 0/* && variant_is_diff*/){
              _this.chosen_variant_compare = variant.id;
              // $("#numberOfPieces").text(variant.inventory_quantity);
              $("#wordPiece").show();
              $("#nameOfPiece").hide();
              $("#numberOfPieces").text(variant.inventory_quantity);
              $("#modalProductTooMuchSelected").show();
              $("body").addClass("modal-open");
              if(variant.inventory_quantity == 1){
                $("#tooMuchSelectedDeny").addClass("display_none");
                $("#tooMuchSelectedDenyOnePiece").removeClass("display_none");
              }else{
                $("#tooMuchSelectedDeny").removeClass("display_none");
                $("#tooMuchSelectedDenyOnePiece").addClass("display_none");
              }
              //remove other text
              $("#tooMuchSelectedContinue").addClass("display_none");
            }
          }
        }else{
          var setState = this._getSetState();
          if(!setState['disabledSet']) {
            $(".product-add-to-cart").removeClass("disabled").removeAttr("disabled");
            if(this.hasRecap){
              document.getElementsByClassName('setRecap_addToCart_notice')[0].classList.add('display_none');
            }
          }else{
            $(".product-add-to-cart").addClass("disabled").attr("disabled","disabled");
            if(this.hasRecap){
              document.getElementsByClassName('setRecap_addToCart_notice')[0].classList.remove('display_none');
            }
          }

          //if superior and here it means we continue selling when oos, print special message
          if(total_quantity > parseInt(variant.inventory_quantity) && variant_is_diff){
            _this.chosen_variant_compare = variant.id;
            // $("#numberOfPieces").text(variant.inventory_quantity);
            $("#wordPiece").show();
            $("#nameOfPiece").hide();
            $("#numberOfPieces").text(variant.inventory_quantity);
            $("#modalProductTooMuchSelected").show();
            $("body").addClass("modal-open");
            $("#tooMuchSelectedContinue").removeClass("display_none");
            $("#tooMuchSelectedDeny").addClass("display_none");
            $("#tooMuchSelectedDenyOnePiece").addClass("display_none");
          }
        }
      }else{
        //if after the value selected in the set there's more of one product than we have in stock and the policy is set to deny
        if(parseInt(variant.inventory_quantity) != 0 && inventory_is_deny){
          $(".product-add-to-cart").addClass("disabled").attr("disabled", true);
          $(".button-add-to-cart-disclaimer-content").addClass("display_none");
          $(".button-add-to-cart-disclaimer-content.tooltipQtySuperior").removeClass("display_none");

          if(parseInt(variant.inventory_quantity) > 0 /*&& variant_is_diff*/){
            _this.chosen_variant_compare = variant.id;
            // $("#numberOfPieces").text(variant.inventory_quantity);
            //if other product, need to get the quantity and display the name of that product from the cart
            //the sku is get when computing the quantity - it only pass when it's a set
            var cart_variant_name = document.querySelector("tr[data-line-sku='"+the_sku_too_much+"'] h4 a").text;
            var cart_max_quantity_variant = document.querySelector("tr[data-line-sku='"+the_sku_too_much+"']").getAttribute("data-line-inventory-quantity");
            $("#wordPiece").hide();
            $("#nameOfPiece").show();
            $("#nameOfPiece").text(cart_variant_name);
            $("#numberOfPieces").text(cart_max_quantity_variant);
            $("#modalProductTooMuchSelected").show();
            $("body").addClass("modal-open");
            if(variant.inventory_quantity == 1){
              $("#tooMuchSelectedDeny").addClass("display_none");
              $("#tooMuchSelectedDenyOnePiece").removeClass("display_none");
            }else{
              $("#tooMuchSelectedDeny").removeClass("display_none");
              $("#tooMuchSelectedDenyOnePiece").addClass("display_none");
            }
            //remove other text
            $("#tooMuchSelectedContinue").addClass("display_none");
          }

        }else{
          $(".product-add-to-cart").removeClass("disabled").removeAttr("disabled");
          $(".button-add-to-cart-disclaimer-content").removeClass("display_none");
          $(".button-add-to-cart-disclaimer-content.tooltipQtySuperior").addClass("display_none");

          //remove other text
          $("#tooMuchSelectedDeny").addClass("display_none");
          $("#tooMuchSelectedDenyOnePiece").addClass("display_none");

          // if(variant.inventory_policy == "continue"){
          //   $("#disclaimer-too-much-item-continue").removeClass("display_none");
          //   $("#setRecap-disclaimer-too-much-item-continue").removeClass("display_none");
          // }
        }
      }
    }// end variant && variant.inventory_management
    //puts the total_quantity value inside a tag -> need to retrieve the value in getShippingDaysAndDate to compute correctly the date if manage stock
    document.querySelector("#productDetails").setAttribute("total_quantity",total_quantity);
    //need to execute handleSoldOutPrint and shippingDate after compareQtyStock, and need the quantity in cart for one case inside handleSoldOutPrint
    _this.shippingDate(product_id, variant_id);
    if(variant && variant.inventory_management){
      _this.handleSoldOutPrint(qty_product_in_cart);
    }

  }//fin compareQtyStock

  ProductProcessing.prototype.buildQtyForSet = function(product_set_sku, current_cart_sku, item_set_qty_in_cart, sku_group, manage_qty, current_cart_set){
    //if component of set does not contain any variations (don't have "-")
    var split_set = product_set_sku.split("/");
    for(var skuset = 0; skuset<split_set.length; skuset++){
      var singlesku = split_set[skuset];
      var allSameSku;
      if(!current_cart_set){
        allSameSku = $(".cart-item[data-line-sku='"+current_cart_sku+"']");
      }else{
        allSameSku = $(".cart-item[data-line-sku='"+current_cart_set+"']");
      }
      if(singlesku.indexOf("-") == -1){
        if(singlesku.indexOf(current_cart_sku) != -1 && manage_qty && current_cart_sku.indexOf("!") == -1){
          //if does not exist in item_set_qty_in_cart
          if(!item_set_qty_in_cart[current_cart_sku.split("-")[0]]){
            // var allSameSku = $(".cart-item[data-line-sku='"+current_cart_sku+"']");
            for(var x=0; x<allSameSku.length;x++){
              item_set_qty_in_cart[current_cart_sku.split("-")[0]] = parseInt(allSameSku[x].querySelector("input").value);
            }
            if(!current_cart_set){
              sku_group[current_cart_sku.split("-")[0]] = current_cart_sku;
            }else{
              sku_group[current_cart_sku.split("-")[0]] = current_cart_set;
            }
          }else{
            for(var x=0; x<allSameSku.length;x++){
              item_set_qty_in_cart[current_cart_sku.split("-")[0]] += parseInt(allSameSku[x].querySelector("input").value);
            }
            if(!current_cart_set){
              sku_group[current_cart_sku.split("-")[0]] += ","+current_cart_sku;
            }else{
              sku_group[current_cart_sku.split("-")[0]] += ","+current_cart_set;
            }
          }
        }else if(singlesku.indexOf(current_cart_sku) != -1 && manage_qty && current_cart_sku.indexOf("!") != -1){
          if(!item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]]){
            for(var x=0; x<allSameSku.length;x++){
              item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]] = parseInt(allSameSku[x].querySelector("input").value) * parseInt(current_cart_sku.split("!")[1]);
            }
            sku_group[current_cart_sku.split("!")[0].split("-")[0]] = current_cart_sku;
          }else{
            for(var x=0; x<allSameSku.length;x++){
              item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]] += parseInt(allSameSku[x].querySelector("input").value) * parseInt(current_cart_sku.split("!")[1]);
            }
            sku_group[current_cart_sku.split("!")[0].split("-")[0]] += ","+current_cart_sku;
          }
        }

      }else{

        if(current_cart_sku.indexOf("!") == -1){
          if( (singlesku.indexOf("-") == -1 &&  singlesku == current_cart_sku) || (singlesku.indexOf("-") !=-1 && singlesku.split("-")[0].indexOf(current_cart_sku.split("-")[0]) != -1) ){
            if(!item_set_qty_in_cart[current_cart_sku.split("-")[0]]){
              for(var x=0; x<allSameSku.length;x++){
                item_set_qty_in_cart[current_cart_sku.split("-")[0]] = parseInt
                (allSameSku[x].querySelector("input").value);
              }
              if(!current_cart_set){
                sku_group[current_cart_sku.split("-")[0]] = current_cart_sku;
              }else{
                sku_group[current_cart_sku.split("-")[0]] = current_cart_set;
              }
            }
            else{
              for(var x=0; x<allSameSku.length;x++){
                item_set_qty_in_cart[current_cart_sku.split("-")[0]] += parseInt(allSameSku[x].querySelector("input").value);
              }
              if(!current_cart_set){
                sku_group[current_cart_sku.split("-")[0]] += ","+current_cart_sku;
              }else{
                sku_group[current_cart_sku.split("-")[0]] += ","+current_cart_set;
              }
            }
          }
        }else{
          if( (singlesku.indexOf("-") == -1 &&  singlesku == current_cart_sku.split("!")[0]) || (singlesku.indexOf("-") != -1 && singlesku.split("-")[0].indexOf(current_cart_sku.split("!")[0].split("-")[0]) != -1) ){
            //if required sku contains "!"
            if(!item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]]){
              for(var x=0; x<allSameSku.length;x++){
                item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]] = parseInt(allSameSku[x].querySelector("input").value) * parseInt(current_cart_sku.split("!")[1]);
              }
              sku_group[current_cart_sku.split("!")[0].split("-")[0]] = current_cart_sku;
            }else{
              for(var x=0; x<allSameSku.length;x++){
                item_set_qty_in_cart[current_cart_sku.split("!")[0].split("-")[0]] += parseInt(allSameSku[x].querySelector("input").value) * parseInt(current_cart_sku.split("!")[1]);
              }
              sku_group[current_cart_sku.split("!")[0].split("-")[0]] += ","+current_cart_sku;
            }
          }
        }
      }
    }

    return [item_set_qty_in_cart, sku_group];

  }//fin buildQtyForSet

  ProductProcessing.prototype.handleModalTooMuchItem = function(){
    var modal = document.getElementById("modalProductTooMuchSelected");
    var btn_close = document.getElementById("closeButtonModalQuantity");
    if(modal){
      modal.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
          $("body").removeClass("modal-open");
        }
      }
    }
    if(btn_close){
      btn_close.onclick = function() {
        modal.style.display = "none";
        $("body").removeClass("modal-open");
      }
    }
  }//fin handleModalTooMuchItem

  ProductProcessing.prototype.handleInfosModal = function(){
    /************************* CODE MODAL ****************************************/
    // Get the modal
    var modal = document.getElementById("modalProduct");
    // Get the button that opens the modal
    var btn = document.getElementById("buttonShowPrice");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks the button, open the modal
    if(btn){
      btn.onclick = function() {
        modal.style.display = "block";
        $("body").addClass("modal-open");
      }

      // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
        modal.style.display = "none";
        $("body").removeClass("modal-open");
      }

      // When the user clicks anywhere outside of the modal, close it
      //change window to modal, to avoid conflict with the cart modal
      modal.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    }

    /* Fill the table with the data receive from from liquid */
    var prodData = ProductsData.products[meta.product.id] ;
    tableToFill = $("#tableBody");

    var availableDate;
    for(var x=0; x < prodData.variants.length ; x++){
      var priceFormatted;
      //moneying to format the price
      priceFormatted = _.moneying(prodData.variants[x].price)
      var stockLimit ="";
      var canOrder = true;
      //safeguard - check if we manage this variant (normally, every variant is managed) - handle manage or not
      //if Date.parse('05/1045654/2021') != "NaN"
      availableDate = ProductsData.availableDates[prodData.variants[x].id];
      if(!availableDate) {
        if(ProductsData.availableDates["product"]){
          availableDate = ProductsData.availableDates["product"];
        }else{
          availableDate = available_date_undefined;
        }
      }
      if(prodData.variants[x].inventory_management){
        stockLimit ="inStock";

        if(prodData.variants[x].inventory_quantity <= 0 ){
          stockLimit = "noStock";
          //get the availabilitydate from the product data - if it does not exists, we put an empty value
          availableDate = ProductsData.availableDates[prodData.variants[x].id];
          if(!availableDate) {
            if(ProductsData.availableDates["product"]){
              availableDate = ProductsData.availableDates["product"];
            }else{
              availableDate = available_date_undefined_no_stock
            }
          }
        }else if(prodData.variants[x].inventory_quantity == 1){
          stockLimit = "almostOos"
        }
        if(prodData.variants[x].inventory_policy == "deny"){
          canOrder = false;
        }
        if(canOrder){
          var pre_order = pre_order_available
        }else{
          var pre_order = pre_order_unavailable
        }
        //test one last time in order to know what to display. Change if there is a date or not (has to indicate preorder or not if there is a date)
        // check if there is an availabilityDate or not
        if(ProductsData.availableDates[prodData.variants[x].id] || ProductsData.availableDates["product"]){
          if(availableDate == "Terminated"){
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='"+stockLimit+"'><td>"+prodData.variants[x].title+"</td><td>"+prodData.variants[x].inventory_quantity+"</td><td>"+terminated+"</td><td>"+priceFormatted+"</td></tr>");
          }else{
            //if there is stock (quantity > 0), print next restock instead of around
            if(prodData.variants[x].inventory_quantity > 0){
              $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='"+stockLimit+"'><td>"+prodData.variants[x].title+"</td><td>"+prodData.variants[x].inventory_quantity+"</td><td>"+next_restock+"<br>"+pre_order+"</td><td>"+priceFormatted+"</td></tr>");
            }else{
              $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='"+stockLimit+"'><td>"+prodData.variants[x].title+"</td><td>"+prodData.variants[x].inventory_quantity+"</td><td>"+around_html+"<br>"+pre_order+"</td><td>"+priceFormatted+"</td></tr>");
            }
            $("#modal-"+prodData.variants[x].id+" .variant-availability-date").append("<span id='dateModal-"+prodData.variants[x].id+"'></span>");
          }
        }else{
          //if in stock and there are shipping date > 1, print the delay of the product, like the messages under the select
          if(prodData.variants[x].inventory_quantity > 0 && (ProductsData.shippingDates[prodData.variants[x].id] > 1 || ProductsData.shippingDates["product"] > 1)){
            var nb_days_production_recap_modal = this.ShippingDate.getProductionTime(meta.product.id, prodData.variants[x].id);
            var shippingInfoModal = this.ShippingDate.getShippingDaysAndDate(meta.product.id, prodData.variants[x].id, {});
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"'><td>"+prodData.variants[x].title+"</td><td>"+translate_made_to_order+"</td><td>"+translate_production+"</td><td>"+priceFormatted+"</td></tr>");

            $("#modal-"+prodData.variants[x].id+" .variant-availability-production").append("<span id='productionModal-"+prodData.variants[x].id+"'></span>");
            $("#modal-"+prodData.variants[x].id+" .variant-availability-date").append("<span id='productionExpeModal-"+prodData.variants[x].id+"'></span>");

            this.ShippingDate.insertShippingDateInHTML("productionModal-"+prodData.variants[x].id, {"days": nb_days_production_recap_modal}, "days");
            this.ShippingDate.insertShippingDateInHTML("productionExpeModal-"+prodData.variants[x].id, shippingInfoModal, "dateShort");

          }else{
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='"+stockLimit+"'><td>"+prodData.variants[x].title+"</td><td>"+prodData.variants[x].inventory_quantity+"</td><td>"+availableDate+"</td><td>"+priceFormatted+"</td></tr>");
          }

        }

        //change if the date  is a date format, to something readable : example => 02/05/2021 become 'may 2nd 2021'
        //if there is no availableDates, they return NaN, so no need to check if data got a date
		    if (!isNaN(Date.parse(availableDate))){
          //convert the available date to a real Date
          shipping_info = {"days":0, "date":new Date(availableDate)};
          //insert the converted date to the unique span created before
          ShippingDate.prototype.insertShippingDateInHTML("dateModal-"+prodData.variants[x].id, shipping_info,"date");
        }

      }else{
        //check if there is a metafield date
        //if it's the correct format and the date is later than today, display out of stock, otherwise, it's in stock
        if (!isNaN(Date.parse(availableDate))){
          if(new Date(availableDate) > new Date()){
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='outOfInStock oosOrderAvail'><td>"+prodData.variants[x].title+"</td><td>"+translate_out_of_stock+"</td><td>"+"Around: <span class='variant-availability-date'></span>"+"<br>"+pre_order_available+"</td><td>"+priceFormatted+"</td></tr>");
            $("#modal-"+prodData.variants[x].id+" .variant-availability-date").append("<span id='dateModal-"+prodData.variants[x].id+"'></span>");
            shipping_info = {"days":0, "date":new Date(availableDate)};
            //insert the converted date to the unique span created before
            ShippingDate.prototype.insertShippingDateInHTML("dateModal-"+prodData.variants[x].id, shipping_info,"date");
          }else{
           $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"'><td>"+prodData.variants[x].title+"</td><td>"+translate_in_stock+"</td><td>"+availableDate+"</td><td>"+priceFormatted+"</td></tr>");
          }
        }else{
          //if suppose to be in stock, check the production time to print the delay of the product, like the messages under the select
          if(ProductsData.shippingDates[prodData.variants[x].id] > 1 || ProductsData.shippingDates["product"] > 1){
            var nb_days_production_recap_modal = this.ShippingDate.getProductionTime(meta.product.id, prodData.variants[x].id);
            var shippingInfoModal = this.ShippingDate.getShippingDaysAndDate(meta.product.id, prodData.variants[x].id, {});
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"' class='instockMadeToOrder'><td>"+prodData.variants[x].title+"</td><td>"+translate_made_to_order+"</td><td>"+"~<span class='variant-availability-production'></span> (~<span class='variant-availability-date'></span>)"+"</td><td>"+priceFormatted+"</td></tr>");

            $("#modal-"+prodData.variants[x].id+" .variant-availability-production").append("<span id='productionModal-"+prodData.variants[x].id+"'></span>");
            $("#modal-"+prodData.variants[x].id+" .variant-availability-date").append("<span id='productionExpeModal-"+prodData.variants[x].id+"'></span>");

            this.ShippingDate.insertShippingDateInHTML("productionModal-"+prodData.variants[x].id, {"days": nb_days_production_recap_modal}, "days");
            this.ShippingDate.insertShippingDateInHTML("productionExpeModal-"+prodData.variants[x].id, shippingInfoModal, "dateShort");

          }else{
            $("#tableBody").append("<tr id='modal-"+prodData.variants[x].id+"'><td>"+prodData.variants[x].title+"</td><td>"+translate_in_stock+"</td><td>"+availableDate+"</td><td>"+priceFormatted+"</td></tr>");
          }
        }
      }
    }
  }//fin handleInfosModal


  //this function aim is to display different div relative to the selected variant
  //we put the out of stock depending on the number of select in the product page, and act following the status of the variant(next availability, out of stock, continue to sell set to deny...)
  ProductProcessing.prototype.handleSoldOutPrint = function( cartQuantity ){
    var _this = this;
    var prodData = ProductsData.products[meta.product.id] ;
    //need to check if selected variant is deny or continue
    var selected_variant = document.getElementById("product-select-"+meta.product.id).value

    // le but est juste d'afficher ou pas en fonction de la situation
    //the aim is to display or not considering the situation
    // display differ considering the number of select in the page
    // 0 -> sold out instead of the select
    // 1 -> indicate sold out in the select for the correct variants
    //2-3 -> sold out in availabilityDate, and display texte considering metafields

    //get the number of select in the page
    var nbSelect = document.querySelectorAll("#productDetails .product-variants .form-group").length;
    if(nbSelect == 1){
      /********** Add the "Out of stock" after the variant name and disable the option ***********/
      var all_var_manage=true;
      var all_var_inv_zero = true;
      var productSelectTag = document.getElementById("product-select-"+meta.product.id+"-option-0");
      for(var i =0; i<prodData.variants.length; i++){
        if(prodData.variants[i].inventory_management && prodData.variants[i].inventory_quantity <=0 && prodData.variants[i].inventory_policy == "deny"){
          //getShippingDayAndDate to add after "sold out" in the select
          var shipD = _this.ShippingDate.getShippingDaysAndDate(meta.product.id,prodData.variants[i].id);
          //if sold out is not already print
          if(productSelectTag.children[i+1].innerHTML.indexOf(" - Sold out") == -1){
            productSelectTag.children[i+1].innerHTML += " - Sold out";
            if(shipD.date){
              if(ProductsData.availableDates[prodData.variants[i].id]){
                if(ProductsData.availableDates[prodData.variants[i].id] == "Terminated"){
                  productSelectTag.children[i+1].innerHTML += " - " + terminated
                }else{
                  productSelectTag.children[i+1].innerHTML += " - "+ProductsData.availableDates[prodData.variants[i].id];
                }
              }
              //productSelectTag.children[i+1].innerHTML += " - "+shipD.date;
            }
          }
          productSelectTag.children[i+1].setAttribute("disabled", true);
        }else if(!prodData.variants[i].inventory_management){
          all_var_manage = false
          all_var_inv_zero = false;
        }else if(prodData.variants[i].inventory_management && prodData.variants[i].inventory_quantity >0){
          all_var_inv_zero = false;
        }
        if(selected_variant && prodData.variants[i].id == selected_variant){
          var select_variant_policy = prodData.variants[i].inventory_policy;
        }
      }
      //check if it's not NaN, then it's a valide date
      if(all_var_manage && all_var_inv_zero && (!isNaN(Date.parse(ProductsData.availableDates["product"])))){
        if(select_variant_policy && select_variant_policy == "continue"){
          document.getElementById("Delay-Status-"+meta.product.id).classList.remove("display_none");;
          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
        }else{
          var DelayDenied = document.getElementById("DelayDenied-Status-"+meta.product.id);
          DelayDenied.classList.remove("display_none");
          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
        }
      //check if it's NaN, then it's not a valide date
      }else if(all_var_manage && all_var_inv_zero && (isNaN(Date.parse(ProductsData.availableDates["product"])))){
        document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
        document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
        document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
        document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
        document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
        document.getElementById("SoldOut-Status-"+meta.product.id).classList.remove("display_none");

      }else if(ProductsData.availableDates["product"] == 1 && !all_var_inv_zero){
        var divStockRecap = document.getElementById("Stock-Status-"+meta.product.id);
        divStockRecap.classList.remove("display_none");
      }
      //if a variant is selected
      else if($("#product-select-"+meta.product.id).val() != '' && !all_var_inv_zero){
        var variant =  _this.getVariantById(prodData,$("#product-select-"+meta.product.id).val());
        var inventory_qty = parseInt(variant.inventory_quantity);
        if(inventory_qty>0){
          if(document.getElementById("quantity").value <= inventory_qty){
            var divStockRecap = document.getElementById("Stock-Status-"+meta.product.id);
            divStockRecap.classList.remove("display_none");
            document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
          }else if(variant.inventory_management == "continue"){
            var divStockRecap = document.getElementById("Delay-Status-"+meta.product.id);
            divStockRecap.classList.remove("display_none");
            document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
          }else if(variant.inventory_management == "deny"){
            var divStockRecap = document.getElementById("DelayDenied-Status-"+meta.product.id);
            divStockRecap.classList.remove("display_none");
            document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
            document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
          }
        }
      }
    }else if(nbSelect == 0){
      if(prodData.variants[0].inventory_management && prodData.variants[0].inventory_quantity <=0){
        //if it's a real date, delay denied, otherwise sold out
        if(!isNaN(Date.parse(ProductsData.availableDates["product"]))){
          var DelayDenied = document.getElementById("DelayDenied-Status-"+meta.product.id);
          DelayDenied.classList.remove("display_none");

          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");

          document.getElementById("Stock-Status-product").classList.add("display_none");
          document.getElementById("Delay-Status-product").classList.add("display_none");
          document.getElementById("NoStock-Status-product").classList.add("display_none");
          document.getElementById("Terminated-Status-product").classList.add("display_none");
          document.getElementById("SoldOut-Status-product").classList.add("display_none");
          document.getElementById("DelayDenied-Status-product").classList.remove("display_none");
        } else if (isNaN(Date.parse(ProductsData.availableDates["product"]))){
          document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.remove("display_none");


          document.getElementById("Stock-Status-product").classList.add("display_none");
          document.getElementById("Delay-Status-product").classList.add("display_none");
          document.getElementById("NoStock-Status-product").classList.add("display_none");
          document.getElementById("Terminated-Status-product").classList.add("display_none");
          document.getElementById("DelayDenied-Status-product").classList.add("display_none");
          document.getElementById("SoldOut-Status-product").classList.remove("display_none");

        }


      }
    }else{ //2-3+ selects
      //get the div to display or not
      var divStockRecap = document.getElementById("Stock-Status-"+meta.product.id);
      var divDelayRecap = document.getElementById("Delay-Status-"+meta.product.id);
      var divNoStockRecap = document.getElementById("NoStock-Status-"+meta.product.id);
      var divDelayDeniedRecap = document.getElementById("DelayDenied-Status-"+meta.product.id);
      var divTerminatedRecap = document.getElementById("Terminated-Status-"+meta.product.id);
      var divSoldOutRecap = document.getElementById("SoldOut-Status-"+meta.product.id);

      //div when set is selected
      var divDelayDeniedRecapProduct = document.getElementById("DelayDenied-Status-product");
      var divStockRecapProduct = document.getElementById("Stock-Status-product");
      var divDelayRecapProduct = document.getElementById("Delay-Status-product");
      var divNoStockRecapProduct = document.getElementById("NoStock-Status-product");
      var divTerminatedRecapProduct = document.getElementById("Terminated-Status-product");
      var divSoldOutRecapProduct = document.getElementById("SoldOut-Status-product");

      //if there's a value == if a variant is selected
      if($("#product-select-"+meta.product.id).val()){
        var variant =  _this.getVariantById(prodData,$("#product-select-"+meta.product.id).val());
        //check for this variant
        //====if manage inventory
        //and====if quantity in stock equal or less than 0;
        //OR==== if qty selected + quantity cart is superior to quantity in inventory
        //and====if got availability date and no production time
        //and====if policy is on deny (if continue, we sell as usual)

        //declare our conditions (easier to read);
        var qty_chosen =  parseInt(document.getElementById("quantity").value);
        var inventory_qty = parseInt(variant.inventory_quantity);

        var availability_date_variant = ProductsData.availableDates[variant.id];
        var shipping_date_variant = ProductsData.shippingDates[variant.id];

        var variant_sku_do_not_have_multiple_and_qty_superior = variant.sku.indexOf("!") == -1 && ((qty_chosen + cartQuantity) > inventory_qty) && availability_date_variant /*&& !shipping_date_variant*/  && variant.inventory_policy == "deny";

        var variant_sku_has_multiple_and_qty_superior = variant.sku.indexOf("!") != -1 && ( (qty_chosen + (Math.ceil(parseInt(cartQuantity) / parseInt(variant.sku.split("!")[1])) ) ) > inventory_qty) && availability_date_variant /*&& !shipping_date_variant*/  && variant.inventory_policy == "deny";

          console.log("================== variant.inventory_management ===============================", variant.inventory_management);
        if(variant.inventory_management && (inventory_qty <=0) && variant.inventory_policy == "deny" || variant_sku_do_not_have_multiple_and_qty_superior || variant_sku_has_multiple_and_qty_superior){
          // if(variant.inventory_management && (parseInt(variant.inventory_quantity) <=0 ) && variant.inventory_policy == "deny"){

          //check if availability date is in currentVariantId
            //inventory_policy => continue
              //same as not stock management, so do nothing
            //inventory_policy => deny
              //availabilityDate => Terminated
              //empty metafield => "Sold out"
              //Estimation next date => availabilityDate ? availabilityDate : productionTime   --> done by _this.ShippingDate.getShippingDaysAndDate

          //if there is no available date, indicate sold out
          console.log("================== ProductsData.availableDates[variant.id] ===============================", ProductsData.availableDates[variant.id]);
          console.log("================== divSoldOutRecap ===============================", divSoldOutRecap);
          console.log("================== divSoldOutRecap ===============================", divSoldOutRecapProduct);
          if(!ProductsData.availableDates[variant.id] || typeof(ProductsData.availableDates[variant.id]) == "undefined" ){
            console.log("ça passe ici")
            if(divStockRecap){divStockRecap.classList.add("display_none");}
            if(divDelayRecap){divDelayRecap.classList.add("display_none");}
            if(divDelayDeniedRecap){divDelayDeniedRecap.classList.add("display_none");}
            if(divTerminatedRecap){divTerminatedRecap.classList.add("display_none");}
            if(divNoStockRecap){divNoStockRecap.classList.add("display_none");}
            if(divSoldOutRecap){divSoldOutRecap.classList.remove("display_none");}

            //div when set is selected
            if(divStockRecapProduct){divStockRecapProduct.classList.add("display_none");}
            if(divDelayRecapProduct){divDelayRecapProduct.classList.add("display_none");}
            if(divDelayDeniedRecapProduct){divDelayDeniedRecapProduct.classList.add("display_none");}
            if(divTerminatedRecapProduct){divTerminatedRecapProduct.classList.add("display_none");}
            if(divNoStockRecapProduct){divNoStockRecapProduct.classList.add("display_none");}
            if(divSoldOutRecapProduct){divSoldOutRecapProduct.classList.remove("display_none");}

          }else{
            //if there is an availableDate metafield for this variant and it's equal to "Terminated" (meaning we don't sell it anymore)
            if(ProductsData.availableDates[variant.id] == "Terminated"){
              //if terminated, show the terminated product div - (wait for the div to be created)
              if(divStockRecap){divStockRecap.classList.add("display_none");}
              if(divDelayRecap){divDelayRecap.classList.add("display_none");}
              if(divDelayDeniedRecap){divDelayDeniedRecap.classList.add("display_none");}
              if(divTerminatedRecap){divTerminatedRecap.classList.remove("display_none");}
              if(divNoStockRecap){divNoStockRecap.classList.add("display_none");}
              if(divSoldOutRecap){divSoldOutRecap.classList.add("display_none");}

              //div when set is selected
              if(divStockRecapProduct){divStockRecapProduct.classList.add("display_none");}
              if(divDelayRecapProduct){divDelayRecapProduct.classList.add("display_none");}
              if(divDelayDeniedRecapProduct){divDelayDeniedRecapProduct.classList.add("display_none");}
              if(divTerminatedRecapProduct){divTerminatedRecapProduct.classList.remove("display_none");}
              if(divNoStockRecapProduct){divNoStockRecapProduct.classList.add("display_none");}
              if(divSoldOutRecapProduct){divSoldOutRecapProduct.classList.add("display_none");}
            }
            // if there is an availableDate metafield for this variant and it's a date - indicate sold out and the date of the restock
            else{
              //if there is an availableDate metafield but it's not a date put the text directly. if it's a date, it's going to be print correctly
              if (isNaN(Date.parse(ProductsData.availableDates[variant.id]))){
                var id = meta.product.id;
                document.getElementById("estimatedDelayDeniedShippingDate-"+id).innerHTML = ProductsData.availableDates[variant.id];
              }

              if(divStockRecap){divStockRecap.classList.add("display_none");}
              if(divDelayRecap){divDelayRecap.classList.add("display_none");}
              if(divDelayDeniedRecap){divDelayDeniedRecap.classList.remove("display_none");}
              if(divTerminatedRecap){divTerminatedRecap.classList.add("display_none");}
              if(divNoStockRecap){divNoStockRecap.classList.add("display_none");}
              if(divSoldOutRecap){divSoldOutRecap.classList.add("display_none");}

              //div when set is selected
              if(divStockRecapProduct){divStockRecapProduct.classList.add("display_none");}
              if(divDelayRecapProduct){divDelayRecapProduct.classList.add("display_none");}
              if(divDelayDeniedRecapProduct){divDelayDeniedRecapProduct.classList.remove("display_none");}
              if(divTerminatedRecapProduct){divTerminatedRecapProduct.classList.add("display_none");}
              if(divNoStockRecapProduct){divNoStockRecapProduct.classList.add("display_none");}
              if(divSoldOutRecapProduct){divSoldOutRecapProduct.classList.add("display_none");}
            }
          }
        }
        //if inventory not handled, act as usual
        //else if(variant.inventory_management){
        //  if(!ProductsData.shippingDates["product"] && !ProductsData.availableDates["product"]){
        //    divStockRecap.classList.add("display_none");
        //    divDelayRecap.classList.add("display_none");
        //    divDelayDeniedRecap.classList.add("display_none");
        //    divTerminatedRecap.classList.add("display_none");
        //    divNoStockRecap.classList.add("display_none");
        //    divSoldOutRecap.classList.add("display_none");
        //  }
        //}

        //test if selected amount <= inventory amount, don't take into account the availability date, so display it in stock
        //only display if variant got availability date metafield, and no production time (otherwise, need to always print the production delay)

        var variant_sku_do_not_have_multiple_and_qty_inferior = variant.inventory_management && variant.sku.indexOf("!") == -1 && ((qty_chosen + cartQuantity) <= inventory_qty) && availability_date_variant && !shipping_date_variant;

        var variant_sku_has_multiple_and_qty_superior = variant.inventory_management && variant.sku.indexOf("!") != -1 && ( (qty_chosen + (Math.ceil(parseInt(cartQuantity) / parseInt(variant.sku.split("!")[1])) ) ) <= inventory_qty) && availability_date_variant && !shipping_date_variant  && variant.inventory_policy == "deny";

        if((variant_sku_do_not_have_multiple_and_qty_inferior || variant_sku_has_multiple_and_qty_superior) && $('#setRecap').hasClass("display_none")){
          if(document.getElementById("Stock-Status-product")){
            document.getElementById("Stock-Status-product").classList.remove("display_none");
          }
          if(document.getElementById("NoStock-Status-product")){
            document.getElementById("NoStock-Status-product").classList.add("display_none");
          }
          if(document.getElementById("Delay-Status-product")){
            document.getElementById("Delay-Status-product").classList.add("display_none");
          }
          if(document.getElementById("DelayDenied-Status-product")){
            document.getElementById("DelayDenied-Status-product").classList.add("display_none");
          }
          if(document.getElementById("Terminated-Status-product")){
            document.getElementById("Terminated-Status-product").classList.add("display_none");
          }
          if(document.getElementById("SoldOut-Status-product")){
            document.getElementById("SoldOut-Status-product").classList.add("display_none");
          }


          if(document.getElementById("Stock-Status-"+meta.product.id)){
            document.getElementById("Stock-Status-"+meta.product.id).classList.remove("display_none");
          }
          if(document.getElementById("Delay-Status-"+meta.product.id)){
            document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          }
          if(document.getElementById("NoStock-Status-"+meta.product.id)){
            document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          }
          if(document.getElementById("DelayDenied-Status-"+meta.product.id)){
            document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
          }
          if(document.getElementById("Terminated-Status-"+meta.product.id)){
            document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          }
          if(document.getElementById("SoldOut-Status-"+meta.product.id)){
            document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
          }
        }//fin  if

      }// end if $("#product-select-"+meta.product.id).val()
      else{ // if no variant selected, loop through all variants, check if inventory management and all inventory = 0, if yes, print sold out
        var all_var_manage=true;
        var all_var_inv_zero = true;
        for(var i =0; i<prodData.variants.length; i++){
          if(!prodData.variants[i].inventory_management){
            all_var_manage = false
            all_var_inv_zero = false;
          } else if(prodData.variants[i].inventory_management && prodData.variants[i].inventory_quantity >0){
            all_var_inv_zero = false;
          }
        }

        if(all_var_manage && all_var_inv_zero && (!isNaN(Date.parse(ProductsData.availableDates["product"])))){
          var DelayDenied = document.getElementById("DelayDenied-Status-"+meta.product.id);
          DelayDenied.classList.remove("display_none");
          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.add("display_none");
        }else if(all_var_manage && all_var_inv_zero && (isNaN(Date.parse(ProductsData.availableDates["product"])))){
          document.getElementById("DelayDenied-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Stock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Delay-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("NoStock-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("Terminated-Status-"+meta.product.id).classList.add("display_none");
          document.getElementById("SoldOut-Status-"+meta.product.id).classList.remove("display_none");

        }
      }
    }// end else

  } // end handleSoldOutPrint

  ProductProcessing.prototype.setInfoShipping = function(country) {
    if(PaidShipping.countries.indexOf(country)>-1){
      // _.each(document.getElementsByClassName('country-shipping-surchage'),function(elt){
      //   elt.classList.remove("display_none");
      // });
      _.each(document.getElementsByClassName('country-shipping-free'),function(elt){
        elt.classList.add("display_none");
      });
    }
    else{
      // _.each(document.getElementsByClassName('country-shipping-surchage'),function(elt){
      //   elt.classList.add("display_none");
      // });
      _.each(document.getElementsByClassName('country-shipping-free'),function(elt){
        elt.classList.remove("display_none");
      });
    }
  };


  ProductProcessing.prototype.setConditionalOption = function() {
    var _this = this;
    var products = document.querySelectorAll("[name='add-item-form']");
    _.each(products, function(product){
      var parents = product.querySelectorAll("[data-selector-wrapper-option-name]");
      _.each(parents, function(parent){
        var childs = product.querySelectorAll('[data-parent="'+parent.dataset.selectorWrapperOptionName+'"]');
        if (childs.length){
          var parent_selector = parent.querySelector("select");
          parent_selector.addEventListener('change', function(){
            _.each(childs, function(child){
              var parent_values = child.dataset.parentValue.toUpperCase().split(";");
              if(parent_values.indexOf(parent_selector.value.toUpperCase()) > -1 ){
                _this.show_element(child);
              }
              else{
                _this.hide_element(child);
              }
            });
          });
        }
      });
    });
  };

  //if(parent_value && parent_value.toUpperCase().split("||||").indexOf(parent_option_value.toUpperCase())>=0){

  ProductProcessing.prototype.hide_element = function(wrapperElement){
    // When hiding: nullify the value of the child-selector's name and save the old value in
    // a data-name property. We don't want to get values from
    // hidden parameters.
    wrapperElement.classList.add("display_none");
    _.each(wrapperElement.querySelectorAll("select, input"), function(elt){
      if(elt.name){
        elt.dataset.name = elt.name
        elt.removeAttribute("name");
      }
      if(elt.required){
        elt.dataset.required = true;
        elt.required = false;
      }
    });
  };

  ProductProcessing.prototype.show_element = function(wrapperElement){
    // When showing: restore the name value.
    wrapperElement.classList.remove("display_none");
    _.each(wrapperElement.querySelectorAll("select, input"), function(elt){
      if(elt.dataset.name){
        elt.setAttribute("name", elt.dataset.name);
      }
      if(elt.dataset.required){
        elt.required = true;
      }
    });
  };

  ProductProcessing.prototype.rearrangeOptions = function() {
    var products = document.querySelectorAll("[name='add-item-form']");
    _.each(products, function(product){
      var options_to_move, i, tmp, j;
      tmp = product.querySelectorAll("[id^='product-select-']");
      options_to_move = product.querySelectorAll("[data-before^='option_']");
      for (i = 0; i < options_to_move.length; i++) {
        index = options_to_move[i].getAttribute("data-before").slice(7);
        if (index >= 0) {
          try {
            tmp[index].parentNode.parentNode.insertBefore(options_to_move[i], tmp[index].parentNode)
          } catch (e) {
            console.log("Option no " + index + " does not exist.")
          }
        }
      }
    });
  };

  /*ProductProcessing.prototype.rearrangeOptions = function(){
    // Rearrange the extra options amongst the built-ins.
    var arr = $("[data-option-position]");
    var dest_form;
    _.each($(arr), function(option,i){
      prod_id = option.getAttribute("data-product-id");
      pos = parseInt(option.getAttribute("data-option-position"));
      dest_form = document.getElementById("add-form-" + prod_id);
      if(dest_form && !isNaN(pos)){
        current_options = dest_form.querySelectorAll("div.selector-wrapper");
        if(current_options.length==0){
          dest_form.insertBefore(option, dest_form.children[0]);
        }else if(pos >= current_options.length){
          dest_form.appendChild(option);
        }else{
          current_options[0].parentNode.insertBefore(option, current_options[pos]);
        }
      }
    }, this);
  };*/


  ProductProcessing.prototype.updateSetPriceDisplay = function(setState, pro_id, variant){
    /**
    * For the modificated product, display the new price and compare_at_price.
    * In the case of an unavailable product, display the unavailability text instead.
   */

    var listProductPrice = document.querySelectorAll('[data-priceProductId="'+pro_id+'"]');
    for(i=0;i<listProductPrice.length;i++){
      if(variant == null || variant.price != 0){
        listProductPrice[i].innerHTML = (variant!=null)? _.moneying(variant.price):"NA";
      }
    }
    var listOldProductPrice = document.querySelectorAll('[data-oldPriceProductId="'+pro_id+'"]');
    for(i=0;i<listOldProductPrice.length;i++){
      listOldProductPrice[i].innerHTML = (variant!=null && (variant.price<variant.compare_at_price))?_.moneying(variant.compare_at_price):"";
    }
    var listProductOutStock = document.querySelectorAll('[data-outStockProductId="'+pro_id+'"]')
    for(i=0;i<listProductOutStock.length;i++){
      listProductOutStock[i].className = (variant!=null && variant.inventory_management=="shopify")?"":"display_none";
    }

    if(!isNaN(setState['setNewPrice'])){
      $("[data-setPriceNew]").html(_.moneying(setState['setNewPrice']));
      if (setState['setOldPrice']>setState['setNewPrice']) {
        $("[data-setPriceOld]").html("("+ _.moneying(setState['setOldPrice'])+")");
      }
      else{
        $("[data-setPriceOld]").empty();
      }
    }
    else {
      $("[data-setPriceNew]").html(setState['setNewPrice']);
      $("[data-setPriceOld]").empty();
    }
  }

   ProductProcessing.prototype._setCommons = function(){
    var set_commons = {};
    set_commons.id = this._newSetId();
    set_commons.qty = 1;// document.getElementById("set_qty").value;
    return set_commons;
  }

  ProductProcessing.prototype._newSetId = function(){
    var d = new Date();
    var set_id = "D"+d.getUTCFullYear()+d.getUTCMonth()+d.getUTCDate()+"-"+"T"+d.getUTCHours()+d.getUTCMinutes()+d.getUTCMilliseconds()
    return set_id;
  };

  ProductProcessing.prototype.isProductReady = function(pid){
    var form = document.getElementById("add-form-"+pid);
    if(!form){
      return false;
    }else if(form.getAttribute("form-disabled")=="true"){
      return false;
    }else{
      return form;
    }
  };

  ProductProcessing.prototype.getFormOptions = function(f) {
    // Get all the options of the given product, free options included.
    var el = f.querySelectorAll(".selector-wrapper"),
        opts = [],
        tmp_opt, option_name, tmp;
    _.each($(el), function(){
      option_name = "";
      if((tmp = $('[data-option-name]', $(this))).length>0){
        option_name = tmp.attr('data-option-name');
      }else if((tmp = $("label", $(this))).length>0){
        option_name = tmp.text();
      }
      var tmp_opt = {};
      if(option_name.indexOf("")>=0){
        option_name = "";
      }
    tmp_opt['name'] = option_name?option_name:"";
      tmp_opt['value'] = $("select, input, textarea", $(this)).eq(0).val();
      tmp_opt['value_with_price'] = $("select option:selected, input, textarea", $(this)).eq(0).html();
      tmp_opt['required'] = this.querySelectorAll('[required]').length >0 && f.getAttribute('form-disabled')=='false';

      opts.push(tmp_opt);
    },this);
    return opts;
  }


  ProductProcessing.prototype.updateCartTotal = function(){
    var forms = $("[name='add-item-form'][form-disabled='false']");
    var set_commons = this._setCommons();
    var line = _.getUrlParameter("line");
    if (line!=undefined && window.XMLHttpRequest){
      var request = new XMLHttpRequest();
      request.onreadystatechange = function() {
        if (request.readyState == 4/* && request.responseText*/) {
          if (request.status == 200) {
            if(forms.length){
              _this.addSetFromForm(forms,set_commons,forms.length-1);
            }
          }
        }
      }
      request.open('POST','/cart/change.js?quantity=0&line='+(parseInt(line)+1),true);
      request.setRequestHeader("Cache-Control", "no-cache");
      request.send();
    }
    else if(window.XMLHttpRequest){
      if(forms.length){
        var fb_prod = ProductsData.products[forms[0].getAttribute('id').replace("add-form-", "")];
        if(typeof(fbq)!=="undefined"){
          fbq('track', 'AddToCart', {
            content_name: fb_prod.handle,
            content_category: fb_prod.type,
            content_ids: [fb_prod.variants[0].id],
            content_type: 'product',
            value: ((this.getVariantById(fb_prod,forms[0].id.value)).price/100).toFixed(2),
            currency:document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary")
            // currency: 'JPY'
          });
        }
        this.addSetFromForm(forms,set_commons,forms.length-1);
      }}
    return false;
  };

  ProductProcessing.prototype.addOversizedItem = function (forms, set_commons, index){
    var _this = this;
    var formData = {
      'items': [{
       'id': 40438264561782, //variant id is specific for the website
       'quantity': 1
       }]
     };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      CartProductsData.oversized_item_id = 40438264561782;
      _this.addSetFromForm(forms, set_commons, index, true);
    })

  }

  //Update 2020 May : We define addAccessoriesFromForm, called by addSetFromForm if an accessory is encountered
  //the function add the product considered as "Recommended Accessories" in the cart
  //without putting a set id on it
  ProductProcessing.prototype.addAccessoriesFromForm = function (forms, set_commons, index) {
    var _this = this;
    formdata = new FormData();
    var elements = forms[index].elements;
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].type != 'file') {
        formdata.append(elements[i].name, elements[i].value)
      } else if (elements[i].files.length > 0) {
        formdata.append(elements[i].name, elements[i].files[0])
      }
    }

    if (!forms[index].querySelector("input[name$='quantity']")) {
      formdata.append("quantity", document.getElementById("quantity").value);
    }
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && (xhr.status == 200)) {
        index--;
          _this.addSetFromForm(forms, set_commons, index);
      }
    };
    xhr.open("POST", "/cart/add.js");
    xhr.send(formdata);
  };

  // We redefine addItemFromForm to be able to upload images dynamically.
  ProductProcessing.prototype.addSetFromForm = function (forms, set_commons, index, skip_oversized) {
    skip_oversized = skip_oversized || false;
    var _this = this;
    //accessories -> recommended product on the page
    //get all the recommended and custom product selected in the page
    //if there is any, accessories.length or custom.length are > 0
    var accessories = $("#product-accessories input[data-state='visible']");
    var custom = $("#customizations.services input[data-state='visible']");
    //check if the browser support HTML5 file upload (FormData object)
    if (window.FormData) {
        document.getElementById("addCartProgress").style.display="block";
        var contentType = 'multipart/form-data';
        formdata = new FormData();
        var elements = forms[index].elements;
        // if overshipped, add overshipped product automatically if not already in the cart
      console.log("add setfromform called")
        if (!CartProductsData.oversized_item_id && !skip_oversized) {
          var is_oversized = false;
          var pro_id = meta.product.id
          var product = ProductsData.products[pro_id];
          for(i = 0;i<product.tags.length;i++){
            if(product.tags[i] == "oversizedShip"){
              console.log("product.tags[i]", product.tags[i]);
              is_oversized = true;
            }
          }

          //do not add oversized if shipping in Japan
          if(is_oversized && document.getElementById("country_selector").value != "Japan"){
            //recall addSetFromForm in addOversizedItem, prevent adding item twice
            _this.addOversizedItem(forms, set_commons, index);
            return;
          }
        }


        //Update 2020 May ---> check if parent of current form is #product-accessories
        //if it's the case, we add it ot the cart in the other function to avoid getting a set_id
        if ($(forms[index]).parents('#product-accessories').length) {
            _this.addAccessoriesFromForm(forms, set_commons, index);
        } else {
          for (var i = 0; i < elements.length; i++) {
            if (elements[i].type != 'file') {
              formdata.append(elements[i].name, elements[i].value)
            } else if (elements[i].files.length > 0) {
              formdata.append(elements[i].name, elements[i].files[0])
            }
          }
          //Update May 2020 : Add condition custom.length
          //check if custom > 0, failsafe to add the set_id
          if (forms.length > 1 && (index == 0 || !forms[index].querySelector("input[name$='quantity']")) && (custom.length > 0)) {
            formdata.append("properties[_set_id]", set_commons.id);
          }
          if (!forms[index].querySelector("input[name$='quantity']")) {
            formdata.append("quantity", document.getElementById("quantity").value);
          }
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && (xhr.status == 200)) {
              if(!document.getElementById("layer")){
                document.body.prepend(Object.assign(document.createElement('div'),{id:"layer", style:"width:100%;height:100%;position:absolute;z-index:9999"}));
              }
              //get the percentage add and make the progress bar larger
              if(index > 0){
                var percent = 100 - (index/forms.length)*100;
                document.getElementById("addCartProgressBar").style.width = percent + "%";
              }
              index--;
              if (index >= 0) {
                _this.addSetFromForm(forms, set_commons, index);
              }
              else {
                document.getElementById("addCartProgressBar").style.width = "100%"
                window.location.href= "/cart";
              }
            }
          };
          xhr.open("POST", "/cart/add.js");
          xhr.send(formdata);
        }
    } else {
      var formdata = null;
      if($(forms[index]).parents('#product-accessories').length){
        //Update May 2020 : if accessories, add withtout the set_id
        formdata = jQuery(forms[index]).serialize();
      }else{
        formdata = jQuery(forms[index]).serialize() + "&properties[_set_id]=" + set_commons.id + "&quantity=" + set_commons.qty;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: formdata,
        dataType: 'json',
        success: function (line_item) {
          index--;
          if (index >= 0) {
            _this.addSetFromForm(forms, set_commons, index);
          }
          else {
            window.location.href = "/cart";
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          console.log('AJAX ERROR:', this, e);
        }
      };
      jQuery.ajax(params);
    }
  };

  ProductProcessing.prototype._checkRequired = function(form){
    var options = form.querySelectorAll('[required]');
    for(var i=0; i<options.length; i++){
      o = options[i];
      if(o.value.trim() == "" || o.value == null || (o.value.toLowerCase() == 'blank' && o.tagName =='SELECT') ){
        return false;
      }
    }
    return true;
  }

  ProductProcessing.prototype.getVariantById = function(product, variant_id){
    for(var i=0;i<product.variants.length;i++){
      var v=product.variants[i];
      if(variant_id==v.id){return v}
    }
    return null;
  }

  ProductProcessing.prototype._getSetState = function(){
    var forms = document.querySelectorAll("[name='add-item-form'][form-disabled='false']");
    var disabledSet = false;
    var setNewPrice = 0;
    var setOldPrice = 0;
    var _this = this;
    _.each(forms,
      function(form, i){
        var p = ProductsData.products[form.getAttribute('id').replace("add-form-", "")];
        var v = _this.getVariantById(p,form.elements["id"].value);
        if(!disabledSet && (v==null || !_this._checkRequired(form) || !v.available)){
          disabledSet = true;
        }
        var qty = form.querySelector("input[name$='quantity']");
        if(!qty){
          qty = document.getElementById("quantity");
        }
        if(!isNaN(setNewPrice) && v!=null){
          setNewPrice += qty.value*v.price;
          setOldPrice += v.compare_at_price? qty.value*v.compare_at_price: qty.value*v.price;
        }
      }, this);
    return {"disabledSet": disabledSet,
            "setNewPrice": setNewPrice,
            "setOldPrice": setOldPrice,
            "isSet": forms.length>1};
  }



  ProductProcessing.prototype.set_main_image = function(pid, variant_id){
    if(variant_id){
      var image = document.querySelector('[data-variant-image*="'+variant_id+'"]');
    }
    if(image){
      var event = document.createEvent('HTMLEvents');
      event.initEvent('click', false, false);
      image.dispatchEvent(event);
    }
    else{
      var product_img = document.getElementById("product-images-"+pid);
      //Switch to main image only if no variant image
      if (product_img && product_img.querySelector("[data-variant-image]")){
        var selector = '[data-image-feature="'+pid+'"]';
        var image = document.querySelector(selector);
        if(image){
          var event = document.createEvent('HTMLEvents');
          event.initEvent('click', false, false);
          image.dispatchEvent(event);
        }
      }
    }
  };


  ProductProcessing.prototype.updateCartInfo = function(cart, cart_count_id, cart_total_id) {
    if ((typeof cart_count_id) === 'string') {
        if (cart.item_count == 0) {
            $('#' + cart_count_id).html('0 items')
        } else if (cart.item_count == 1) {
            $('#' + cart_count_id).html('1 item')
        } else {
            $('#' + cart_count_id).html(cart.item_count + ' items')
        }
    }

    if ((typeof cart_count_id) === 'string') {
      var totalPriceId = $("#" + cart_total_id + " .money").eq(0);
      var newPriceShopCurrency = "";

      newPriceShopCurrency = Currency.formatMoney(cart.total_price,Currency.moneyFormats[shopCurrency]["money_with_currency_format"]);
      totalPriceId.attr("data-currency-"+shopCurrency.toLowerCase(), newPriceShopCurrency);
      if(Currency.currentCurrency != shopCurrency){
        var currentPriceAttribute = "data-currency-" + totalPriceId.attr("data-currency").toLowerCase();
        var newPriceCurCurrency =  Currency.formatMoney(Currency.convert(cart.total_price*1.04,shopCurrency, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency]["money_with_currency_format"]);
        totalPriceId.attr(currentPriceAttribute, newPriceCurCurrency);
      }else{
        var newPriceCurCurrency = newPriceShopCurrency;
      }
      totalPriceId.html(newPriceCurCurrency);
    }
  };


  ProductProcessing.prototype.shippingDate = function(pro_id, var_id){
    //Shipping date
    var divStockRecap = document.getElementById("Stock-Status-product");
    var divNoStockRecap = document.getElementById("NoStock-Status-product");
    var divDelayRecap = document.getElementById("Delay-Status-product");
     //Add new status for stock management
    var divDelayDeniedRecap = document.getElementById("DelayDenied-Status-"+meta.product.id);
    var divTerminatedRecap = document.getElementById("Terminated-Status-"+meta.product.id);
    var divSoldOutRecap = document.getElementById("SoldOut-Status-"+meta.product.id);


    //remove by default div when set is selected - handleSoldOutPrint will remove display_none if needed
    document.getElementById("DelayDenied-Status-product").classList.add("display_none");
    document.getElementById("Terminated-Status-product").classList.add("display_none");
    document.getElementById("SoldOut-Status-product").classList.add("display_none");

    //find the longest production time of the set
    var tmp_date_max = new Date();
    var tmp_date = null;
    var forms = $("[name='add-item-form'][form-disabled='false']");
    var product_id;
    var variant_id;
    var is_set_om = false; // if order made no exchange
    _.each(forms,function(form, i){
      var p_id = form.getAttribute('id').replace("add-form-", "");
      var v_id = form.elements["id"].value;
      tmp_date = this.ShippingDate.getShippingDaysAndDate(p_id, v_id).date;
      if(tmp_date>tmp_date_max){
        tmp_date_max = tmp_date;
        product_id = p_id;
        variant_id = v_id;
      }
      if(!is_set_om && ProductsData.products[p_id].tags.indexOf("noExchange") > -1){
        is_set_om = true
      }
    }, this);

    // shippingInfo will be object {dways, date}
    var shippingInfo = this.ShippingDate.getShippingDaysAndDate(product_id, variant_id, {});
    //need to compute the true date if the product_id of the selected product is with a + (basically if it's a service)
    if(ProductsData.shippingDates[product_id] && ProductsData.shippingDates[product_id].indexOf("+") != -1){
      var item_selected_id = document.querySelector("#product-select-"+meta.product.id).value;
      if(item_selected_id && item_selected_id != ''){
        //if the selected variant is also a production time with a +, need to take the higher value between the two, and use the product value (meta.product.id) to compute
        if(ProductsData.shippingDates[item_selected_id] && (ProductsData.shippingDates[item_selected_id].indexOf("+") != -1)){
          if(parseInt(ProductsData.shippingDates[item_selected_id]) > parseInt(ProductsData.shippingDates[product_id])){
            var nb_days_production_recap = this.ShippingDate.getProductionTime(meta.product.id, item_selected_id);
          }else{
            var nb_days_production_recap = this.ShippingDate.getProductionTime(meta.product.id, product_id);
          }
        }else{
          if(ProductsData.shippingDates[item_selected_id]){
            //case if a variant got a production time which is not an offset, need to take this variant production time instead of te product (meta.product.id) productionTime
            var nb_days_production_recap = this.ShippingDate.getProductionTime(item_selected_id, product_id);
          }else{
            var nb_days_production_recap = this.ShippingDate.getProductionTime(meta.product.id, product_id);
          }
        }
      }else{
        var nb_days_production_recap = this.ShippingDate.getProductionTime(meta.product.id, product_id);
      }
    }else{
      var nb_days_production_recap = this.ShippingDate.getProductionTime(product_id, variant_id);
    }
    if(nb_days_production_recap){
      //If availability date
      if (shippingInfo.isDelayed) {
        if(divNoStockRecap){divNoStockRecap.classList.add("display_none");}
        if(divStockRecap){divStockRecap.classList.add("display_none");}
        if(divTerminatedRecap){divTerminatedRecap.classList.add("display_none");}
        if(divSoldOutRecap){divSoldOutRecap.classList.add("display_none");}
        if(divDelayDeniedRecap){divDelayDeniedRecap.classList.add("display_none");}
        if(divDelayRecap){
          divDelayRecap.classList.remove("display_none");
          document.getElementById("estimatedDelayDate-product").classList.remove("display_none");
          //if available date = no
          if(shippingInfo.days==9999){
            var domElement = document.getElementById("estimatedDelayShippingDate-product");
            if (domElement) {domElement.innerHTML = "Not Available";}
          }
          else{
            this.ShippingDate.insertShippingDateInHTML("estimatedDelayShippingDate-product", shippingInfo, "date");
            //differentiate if manage stock product or not, but need the date
            this.ShippingDate.insertShippingDateInHTML("estimatedDelayDeniedShippingDate-product", shippingInfo, "date");
          }
        }
      }
      //if no stock
      else if (nb_days_production_recap > 1) {
        if(divNoStockRecap){
          this.ShippingDate.insertShippingDateInHTML("estimatedProduction-product", {"days": nb_days_production_recap}, "days");
          this.ShippingDate.insertShippingDateInHTML("estimatedShipping-product", shippingInfo, "date");
          //insert date in delay denied, can be print in a specific condition (when selecting service and then selecting a delay product)
          this.ShippingDate.insertShippingDateInHTML("estimatedDelayDeniedShippingDate-product", shippingInfo, "date");
          var elt_exachange_message = document.getElementById("exchange_message_recap");
          if (elt_exachange_message){
            if(is_set_om){elt_exachange_message.classList.remove("display_none");}
            else{elt_exachange_message.classList.add("display_none");}
          }
          divNoStockRecap.classList.remove("display_none");
        }
        if(divStockRecap){divStockRecap.classList.add("display_none");}
        if(divDelayRecap){divDelayRecap.classList.add("display_none");}
        if(divTerminatedRecap){divTerminatedRecap.classList.add("display_none");}
        if(divSoldOutRecap){divSoldOutRecap.classList.add("display_none");}
        if(divDelayDeniedRecap){divDelayDeniedRecap.classList.add("display_none");}
      }
      //if stock
      else if (nb_days_production_recap <= 1) {
        if(divNoStockRecap){divNoStockRecap.classList.add("display_none");}
        if(divStockRecap){
          divStockRecap.classList.remove("display_none");
          //If holidays
          if(shippingInfo.days>1){
            this.ShippingDate.insertShippingDateInHTML("estimatedShippingDate-product", shippingInfo, "date");
            document.getElementById("estimatedShippingHoliday-product").classList.remove("display_none");
          }
          else{document.getElementById("estimatedShippingHoliday-product").classList.add("display_none");}
        }
        if(divDelayRecap){divDelayRecap.classList.add("display_none");}
        if(divTerminatedRecap){divTerminatedRecap.classList.add("display_none");}
        if(divSoldOutRecap){divSoldOutRecap.classList.add("display_none");}
        if(divDelayDeniedRecap){divDelayDeniedRecap.classList.add("display_none");}
      }
    }

    if(pro_id){
      // If modify the main product, need to modify the service
      forms = forms[0].getAttribute('id').replace("add-form-","")==pro_id ?
        document.querySelectorAll("[name='add-item-form']") : [document.querySelector("#add-form-"+pro_id)];

      // Display days/date in NoStock div (always exists)
      _.each(forms,function(form, i){
        var id = form.getAttribute('id').replace("add-form-","")
        var divStock = document.getElementById("Stock-Status-"+id);
        var divNoStock = document.getElementById("NoStock-Status-"+id);
        var divDelay = document.getElementById("Delay-Status-"+id);
        // shippingInfo will be object {days, date}
        shippingInfo = this.ShippingDate.getShippingDaysAndDate(id, form.id.value, {});
        var nb_days_production = this.ShippingDate.getProductionTime(id, form.id.value);
        if(nb_days_production){
          if (shippingInfo.isDelayed) {
            if (divNoStock){divNoStock.classList.add("display_none");}
            if (divStock){divStock.classList.add("display_none");}
            if(divDelay){
              divDelay.classList.remove("display_none");
              if(shippingInfo.days==9999){
                var domElement = document.getElementById("estimatedDelayDate-"+id);
                if(domElement){domElement.classList.add("display_none");}
                domElement = document.getElementById("estimatedDelayMessage-"+id);
                if(domElement){
                  domElement.innerHTML = shippingInfo.date;
                  domElement.classList.remove("display_none");
                }
              }
              else{
                var domElement = document.getElementById("estimatedDelayMessage-"+id);
                if(domElement){domElement.classList.add("display_none");}
                var domElement = document.getElementById("estimatedDelayDate-"+id);
                if(domElement){domElement.classList.remove("display_none");}
                this.ShippingDate.insertShippingDateInHTML("estimatedDelayShippingDate-"+id, shippingInfo, "date");
                //differentiate if manage stock product or not, but need the date
                this.ShippingDate.insertShippingDateInHTML("estimatedDelayDeniedShippingDate-"+id, shippingInfo, "date");
              }
            }
          }
          else if (nb_days_production > 1){
            if (divNoStock) {
              this.ShippingDate.insertShippingDateInHTML("estimatedProduction-"+id, {"days": nb_days_production}, "days");
              this.ShippingDate.insertShippingDateInHTML("estimatedShipping-"+id, shippingInfo, "date");
              divNoStock.classList.remove("display_none");
            }
            if(divStock){divStock.classList.add("display_none");}
            if(divDelay){divDelay.classList.add("display_none");}
          }
          else if(nb_days_production <=1){
            if (divNoStock){divNoStock.classList.add("display_none");}
            if (divStock) {
              divStock.classList.remove("display_none");
              //If holidays
              if(shippingInfo.days>1){
                this.ShippingDate.insertShippingDateInHTML("estimatedShippingDate-"+id, shippingInfo, "date");
                document.getElementById("estimatedShippingHoliday-"+id).classList.remove("display_none");
              }
              else{document.getElementById("estimatedShippingHoliday-"+id).classList.add("display_none");}
            }
            if(divDelay){divDelay.classList.add("display_none");}
          }
        }
      }, this);
    }
  }

  ProductProcessing.prototype.selectCallback = function(pro_id, variant) {
    // The selectCallback is called at selectors' onchange.
    // variant and selector are set only if a change in selected variants occured.
    var setState = this._getSetState();
    this.updateSetPriceDisplay(setState, pro_id, variant);
    if(setState["isSet"]){
      _.each(document.querySelectorAll('.noService_buyZone'), function(buy_zone){
        buy_zone.classList.add('display_none');
      });
    }
    else{
      _.each(document.querySelectorAll('.noService_buyZone'), function(buy_zone){
        buy_zone.classList.remove('display_none');
      });
    }
    if(!setState['disabledSet']) {
      $(".product-add-to-cart").removeClass("disabled").removeAttr("disabled");
      if(this.hasRecap){
        document.getElementsByClassName('setRecap_addToCart_notice')[0].classList.add('display_none');
      }
    }
    else{
      $(".product-add-to-cart").addClass("disabled").attr("disabled","disabled");
      if(this.hasRecap){
        document.getElementsByClassName('setRecap_addToCart_notice')[0].classList.remove('display_none');
      }
    }
    if(cookies.getItem("unitSystem")=="imperial"){
      var options = document.querySelectorAll("option[data-imperial]");
      _.each(options, function(option){
        option.innerHTML = option.innerHTML.replace(option.value,option.dataset.imperial);
      });
    }
    if(pro_id)
    {
      var variant_id = document.getElementById('product-select-'+pro_id).value;
      this.set_main_image(pro_id, variant_id);
    }
    this.shippingDate(pro_id, variant_id);
    //this.handleSoldOutPrint();
    this.compareQtyStock();
    // if('USD CAD EUR GBP AUD CHF HKD NZD SGD KRW RUB' != ''){
    //   Currency.convertAll('JPY', document.querySelector('[name=currencies]').value);
    // }
  };

  module.exports = ProductProcessing;

  },{"./_cookies.js":1,"./_lib.js":3,"./_paid-shipping.js":4,"./_shipping-date.js":8}],7:[function(require,module,exports){
  var _ = require('./_lib.js');
  var ProductProcessing = require('./_product-processing.js');

  /* Functions to handle the option selectors for every products */
    var ProductSelectors = function() {
      this.PP = new ProductProcessing(this);
      this.setSelectors();
      this.setCheckboxs();
    };

    /* Init function to add the event listeners on the selectors */
    ProductSelectors.prototype.setSelectors = function(){
      /*
      * If no customization has been chosen when the product has been added to the cart
      * a link to customize it is displayed in the cart.
      * If coming via that link a preselection of the product's options is made with the values in the URL
      * getVariantById defined in ProductProcessing
      */
      var main_product = ProductsData.products[document.querySelector("[name='add-item-form']").getAttribute('id').replace("add-form-", "")];
      var variant_id = _.getUrlParameter("variant");
      if(variant_id!=undefined){
        var variant = this.PP.getVariantById(main_product,variant_id);
        if(main_product.variants.length > 1){
          if(variant){
            document.getElementById('product-select-'+main_product.id+'-option-0').value = variant.option1;
            if(variant.option2!=null){
              document.getElementById('product-select-'+main_product.id+'-option-1').value = variant.option2;
              if(variant.option3!=null){
                document.getElementById('product-select-'+main_product.id+'-option-2').value = variant.option3;
              }
            }
          }
        }
      }
      /* Add the event listeners
         selectCallback defined in ProductProcessing
      */
      var selectors = document.querySelectorAll("[data-select-product]");
      var _this = this;
      _.each(selectors, function(selector, index){
          _this.selectorHandling(selector, selector.dataset.selectProduct);
          selector.addEventListener('change', function(){
            if (this.value != 'default' && this.value != "") {
              this.classList.add('selected');
            } else {
              this.classList.remove('selected');
            }
            var ids = _this.selectorHandling(selector, this.dataset.selectProduct);
            _this.PP.selectCallback(ids["pro_id"],ids["variant"]);
          });
        }, this);
      if(typeof(variant)==="undefined" || variant==null){
        var variant = this.getVariantWithOption(main_product,"default");
      }
      this.PP.selectCallback(main_product.id, variant);
    }

    /*
      * Main function to handle option selector
      */
    ProductSelectors.prototype.selectorHandling = function(selector, pro_id){
      /* Get the values of the option selector */
      var product = ProductsData.products[pro_id];
      var variant;
      var selector1 = document.getElementById("product-select-"+pro_id+"-option-0");
      var opt1 = selector1.value;
      var selector2 = document.getElementById("product-select-"+pro_id+"-option-1")
      var opt2 = (selector2)?selector2.value:null;
      var selector3 = document.getElementById("product-select-"+pro_id+"-option-2")
      var opt3 = (selector3)?selector3.value:null;

      /* Find if any variant can match the option choice */
      variant = this.getVariantWithOption(product,opt1,opt2,opt3);
      /* Save the variant only if all options has been chosen and matching variant has been found */
      if(variant!=null&&[opt1,opt2,opt3].indexOf("default")<0){
        document.getElementById('product-select-'+pro_id).value = variant.id;
        var checkbox = document.getElementById('checkbox-'+pro_id)
        if(checkbox){
          checkbox.checked = true;
          var event = document.createEvent('HTMLEvents');
          event.initEvent('change', false, false);
          checkbox.dispatchEvent(event);
        }
      }
      else{
        document.getElementById('product-select-'+pro_id).value = "";
      }

      document.getElementById("selector-alert-"+pro_id).classList.add("display_none");
      /*
      * Reset to default value if all options has been chosen and can't matching variant
      * But keep the option value for last changed option selector
      */
      if(variant==null && [opt1,opt2,opt3].indexOf("default")<0){
        if(selector!=selector1){
          selector1.value="default";
          selector1.classList.remove('selected');
          opt1 = selector1.value;
        }
        if(opt2&&selector!=selector2){
          selector2.value="default";
          selector2.classList.remove('selected');
          opt2 = selector2.value;
        }
        if(opt3&&selector!=selector3){
          selector3.value="default";
          selector3.classList.remove('selected');
          opt3 = selector3.value;
        }
        document.getElementById("selector-alert-"+pro_id).classList.remove("display_none");
        variant = this.getVariantWithOption(product,opt1,opt2,opt3);
      }

      /*
      * To check the availability of every combination
      * First put unavailable everywhere
      */
      for(j=1;j<selector1.options.length;j++){
        var o = selector1.options[j];
        // o.innerHTML = o.value +" - Unavailable with values selected on this option";
        o.innerHTML = o.value + translationJSon.javascript.product.option_variant_unavailable[laLang];
      }
      if(opt2){
        for(j=1;j<selector2.options.length;j++){
          var o = selector2.options[j];
          // o.innerHTML = o.value +" - Unavailable with values selected on this option";
          o.innerHTML = o.value + translationJSon.javascript.product.option_variant_unavailable[laLang];
        }
        if(opt3){
          for(j=1;j<selector3.options.length;j++){
            var o = selector3.options[j];
            // o.innerHTML = o.value +" - Unavailable with values selected on this option";
            o.innerHTML = o.value + translationJSon.javascript.product.option_variant_unavailable[laLang];
          }
        }
      }

      /*
      * For every combination of the option(s) already selected, find the cheapest one to indicate the price difference
      * var cheapestVariant is used when the combination is unavailable with the option selected
      */

      for(i=0; i< product.variants.length; i++){
        var v = product.variants[i];

        if(opt3){
          if((opt1 == v.option1 || opt1 == "default") && (opt2 == v.option2 || opt2 == "default")){
            var tmp_var = this.getVariantWithOption(product,opt1,opt2,v.option3);
            if(variant==null){var cheapestVariant= this.getVariantWithOption(product,opt1,opt2,"default")};
            this.updateSelectors(product,selector3,tmp_var.option3,(variant?tmp_var.price-variant.price:cheapestVariant.price));
          }
          if((opt2 == v.option2 || opt2 == "default")&& (opt3 == v.option3 || opt3 == "default")){
            var tmp_var = this.getVariantWithOption(product,v.option1,opt2,opt3);
            if(variant==null){var cheapestVariant= this.getVariantWithOption(product,"default",opt2,opt3)};
            this.updateSelectors(product,selector1,tmp_var.option1,(variant?tmp_var.price-variant.price:cheapestVariant.price));
          }
          if((opt1 == v.option1 || opt1 == "default") && (opt3 == v.option3 || opt3 == "default")){
            var tmp_var = this.getVariantWithOption(product,opt1,v.option2,opt3);
            if(variant==null){var cheapestVariant= this.getVariantWithOption(product,opt1,"default",opt3)};
            this.updateSelectors(product,selector2,tmp_var.option2,(variant?tmp_var.price-variant.price:cheapestVariant.price));
          }
        }
        else if(opt2){
          if(opt1 == v.option1 || opt1 == "default"){
            var tmp_var = this.getVariantWithOption(product,opt1,v.option2);
            this.updateSelectors(product,selector2,v.option2,tmp_var.price-variant.price);
          }
          if(opt2 == v.option2 || opt2 == "default"){
            var tmp_var = this.getVariantWithOption(product,v.option1,opt2);
            this.updateSelectors(product,selector1,v.option1,tmp_var.price-variant.price);
          }
        }
        else{
          var tmp_var = this.getVariantWithOption(product,v.option1);
          this.updateSelectors(product,selector1,v.option1,tmp_var.price-variant.price);
        }
      }

      //Update January 2021 => add this to handle the out of stock case when there is only one select
        //november 2021 -> uncomment this, don't know why it was commented
        var id_main_product="";
        if(document.querySelector("#productOptionsWrapper select")){
          id_main_product = document.querySelector("#productOptionsWrapper select").getAttribute("data-select-product");
        }
      if (document.querySelectorAll("#productDetails .product-variants .form-group").length == 1 && pro_id == id_main_product){
        this.PP.handleSoldOutPrint(0);
      }


      return {"pro_id":pro_id,
              "variant": variant};
    }


    /*
    * Function to change the text inside the option value
    * It add the price variation and delete " - Unavailable with selected values"
    */
    ProductSelectors.prototype.updateSelectors = function(product, selector, opt, diff_price){
      for(j=0;j<selector.options.length;j++){
        var o = selector.options[j];
        if (o.value == opt) {
          o.innerHTML = o.value;
          if (diff_price != 0) {
            o.innerHTML += (product.price_varies ? " [" + ((diff_price<0)?"-":"+")  +_.moneying(Math.abs(diff_price))+"]" : "");
            o.removeAttribute("disabled");
          }
        }
      }
    }

    /*
    * If several variant possible, the cheapest is returned
    * The "default" value is used as wild card
    */
    ProductSelectors.prototype.getVariantWithOption = function(product, opt1, opt2, opt3){
      if (typeof(opt2)==='undefined'||opt2==null) {opt2 = "default";}
      if (typeof(opt3)==='undefined'||opt3==null) {opt3 = "default";}
      var variant_min_price;
      for(j=0; j< product.variants.length; j++){
        var v = product.variants[j];
        if((v.option1==opt1||opt1 == "default")&&(v.option2==opt2||opt2 == "default") && (v.option3==opt3||opt3 == "default")){
          variant_min_price = (variant_min_price==null || parseInt(variant_min_price.price) > parseInt(v.price))?v:variant_min_price;
          if(opt1!="default"&&opt2!="default"&&opt3!="default"){
            break;
          }
        }
      }
      return variant_min_price;
    }



    ProductSelectors.prototype.setCheckboxs = function(){
      var _this = this;
      var checkboxs = document.querySelectorAll('[data-cbx-id]');
      _.each(checkboxs,function(checkbox, index){
          checkbox.checked = false;
          checkbox.addEventListener('change', function(){
            _this.checkboxHandling(checkbox)
            _this.PP.selectCallback();
          });
        },this);
    }

    /*
     * Products checkbox to display recap price and to enabled/disabled form
     */
    ProductSelectors.prototype.checkboxHandling = function(checkbox){
      var id = checkbox.dataset.cbxId
      var form = document.getElementById('add-form-'+id);
      if(form.length){
        if(checkbox.checked){
          form.setAttribute("form-disabled","false");
          document.getElementById("recap-price-id-"+id).classList.remove('display_none');
        }
        else{
          form.setAttribute("form-disabled","true");
          document.getElementById("recap-price-id-"+id).classList.add('display_none');
        }
      }

      var recap = document.getElementById('setRecap');
      var recapLink = document.getElementById('setRecapLink');
      var isCustomProductTemplate = document.body.classList.contains('product-jisei');
      if (!isCustomProductTemplate) {
        if(document.querySelector('[data-cbx-id]:checked')!==null){
          recap.classList.remove("display_none");
          recapLink.classList.remove("display_none");
        }
        else{
          recap.classList.add("display_none");
          recapLink.classList.add("display_none");
        }
      }
    };

    module.exports = ProductSelectors;

  },{"./_lib.js":3,"./_product-processing.js":6}],8:[function(require,module,exports){
  var ShippingDate = function(){
  };
  /**
    * @desc Checks if day is shop holiday or not
    * @param Date date - Day to check if shop holiday or not (could be of any type supported by the dateFn.convert function )
    *
    * @return Bool - True if day is shop holiday, else otherwise
  */
    ShippingDate.prototype.dateIsShopHoliday = function(date) {
      // Retrieve shop holiday from meta-data (variable shopHolidayList)
      // Format is date1;date2;fromDate1/toDate1;fromDate2/toDate2;
      for(i=0;i<CoreInit.holidayDates.length;i++)
        if(Array.isArray(CoreInit.holidayDates[i])){
          if (this.inRange(date, CoreInit.holidayDates[i][0],CoreInit.holidayDates[i][1])) { return true; }
        }
        else{
          if (this.compare(date, CoreInit.holidayDates[i]) == 0) { return true; }
        }
      return false;
    };



  /**
    * @desc Calculate shipping date for specific product/variant, taking into account rules (week-end, holiday...)
    * @param Integer $variant_id - Id of variant for which to get the productionTime
    * @param Hash $options - Additional options:
        day_end_time (String HH) - time after which order will be processed next day
        skip_weekend (Bool) - Skip week-ends when calculating next day
        skip_shopholiday (Bool) - Skip shop holidays when calculating next day
        skip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
    *
    * @return Date - Returns shipping date
  */

    ShippingDate.prototype.getProductionTime = function(product_id, variant_id) {
      var days_nb = (typeof(ProductsData)!=="undefined") ? ProductsData.shippingDates[variant_id] : CartProductsData.shippingDates[variant_id];
      days_nb = days_nb ||  ((typeof(ProductsData)!=="undefined") ? ProductsData.shippingDates[product_id] : CartProductsData.shippingDates[product_id]);
      if (days_nb) {
        if(days_nb.indexOf("+") != -1 && typeof(ProductsData)!=="undefined"){
          if(isNaN(days_nb.toString()[0])){days_nb=days_nb.toString().substring(1);}
          days_nb = parseInt(days_nb) + parseInt(ProductsData.shippingDates[product_id]);
        }
        return days_nb;
      }
      else{
        return "1";
      }
    };


  /**
    * @desc Calculate shipping date (with days till shipping) for specific product/variant, taking into account rules (week-end, holiday...)
    *       Variant production time can be either absolute value (ex: 10) or offset from product production time (ex: +2, -4)
    * @param Integer $variant_id - Id of variant for which to get the productionTime
    * @param Hash $options - Additional options:
        day_end_time (String HH) - time after which order will be processed next day
        skip_weekend (Bool) - Skip week-ends when calculating next day
        skip_shopholiday (Bool) - Skip shop holidays when calculating next day
        skip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
    *
    * @return Object{$days, $date} - Return number of days till shipping date + shipping date using offset and rules
  */

    ShippingDate.prototype.getShippingDaysAndDate = function(product_id, variant_id, options) {
      options = options || {};
      var productionTimes = (typeof(ProductsData)!=="undefined") ? ProductsData.shippingDates : CartProductsData.shippingDates;
      var availableDates = (typeof(ProductsData)!=="undefined") ? ProductsData.availableDates : CartProductsData.availableDates;
      var shippingDate = null;
      var days_nb = null;
      var today = new Date();
      today.setHours(0,0,0,0)
      //var days_nb = variant_id ? (productionTimes[variant_id] ? productionTimes[variant_id] : productionTimes["Product"]) : productionTimes["Product"];

      //ignore availability date if the selected quantity is inferior or equal to the one in stock
      var ignore_availability_date = false;
      var selected_variant = null;
      var product_variant_id = $("#product-select-"+meta.product.id).val();
      //get the selected variant info
      if(product_variant_id){
        var product = ProductsData.products[meta.product.id];
        var the_variant_id = product_variant_id;
        for(var i=0;i<product.variants.length;i++){
          var v=product.variants[i];
          if(the_variant_id==v.id){selected_variant = v}
        }

        var total_quantity = document.querySelector("#productDetails").getAttribute("total_quantity");
        //if we get the variant and if we manage the stock but quantity selected < to the one in stock, ignore the availability_date
        if(selected_variant && selected_variant.inventory_management && total_quantity <= parseInt(selected_variant.inventory_quantity)){
          ignore_availability_date = true;
        }
      }

      if(variant_id){
        days_nb = productionTimes[variant_id];
      }
      if(!days_nb && product_id){
        days_nb = productionTimes[product_id];
      }
      //if no productionTime is set, set it at 1
      if(!days_nb){
        days_nb = "1"
      }
      if (days_nb) {
        // Check if variant's production time is absolute value or offset (based on product's production time)
        var firstChar = days_nb.toString()[0];
        var availableDate = availableDates[variant_id];
        var isDelayed = false;
        if(!availableDate){availableDate = availableDates[product_id]};
        if(availableDate==undefined){
          availableDate = today;
        }
        else if(this.convert(availableDate)=="Invalid Date"){
          return{"days": 9999,
                  "date": availableDate,
                  "isDelayed": true};
        }
        else{
          availableDate = this.convert(availableDate)
        }

        if(availableDate<=today || ignore_availability_date){
          availableDate = today;
        }
        else{
          //if the selected variant got a +production time (like seido finish) and a date, need to add the delay to the date
          if(firstChar == "+"){
            days_nb = parseInt(days_nb.toString().substring(1));
            // availableDate.setDate(availableDate.getDate()+days_nb);
            var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
            availableDate = shipInfo.date;
          }
          return{"days": 99,
                  "date": availableDate,
                  "isDelayed": true};
        }

        // Production time is an offset
        if(firstChar == '+' || firstChar == '-' ){
          days_nb = parseInt(days_nb.toString().substring(1));
          var main_variant_id = $('[name="id"]:first').val(); //Only on product always empty on cart
          main_variant_id = main_variant_id || "product";

          var main_availableDate = availableDates[main_variant_id];
          //NOT AVAILABLE
          if((typeof(main_availableDate)=="string" && main_availableDate.toLocaleLowerCase()=="no")
              ||(typeof(availableDate)=="string" && availableDate.toLocaleLowerCase()=="no")){
            return {"days": null,
                    "date": null,
                    "isDelayed": false};
          }

          //if no availability in the variant, check the one in the product
          main_availableDate = main_availableDate==undefined? availableDates["product"] : this.convert(main_availableDate);
          //Available date undefined or already passed
          main_availableDate = main_availableDate==undefined? today : this.convert(main_availableDate);
          if(isNaN(main_availableDate.getTime()) || main_availableDate<today){main_availableDate = today;}
          if(isNaN(availableDate.getTime()) || availableDate<today){availableDate = today;}

          //Shipping time for the main product
          var main_productionTime = productionTimes[main_variant_id];
          if(main_productionTime && productionTimes[main_variant_id].toString()[0] == "+"){
            //if a +, take the product time by default, and the + time will be add below after the if condition by doing both getNextDaysAndDate (one with the product date set here, and the other with the days_nb, which equals the +offset value)
            main_productionTime = parseInt(productionTimes["product"]);
          }
          main_productionTime = main_productionTime?parseInt(main_productionTime):parseInt(productionTimes["product"]);

          if(product_variant_id){
            if(selected_variant && selected_variant.inventory_management && total_quantity <= parseInt(selected_variant.inventory_quantity)){
              main_availableDate = today;
            }
          }

          //Positif offset
          if(firstChar == '+'){
            //if there is an availablityDate (in variant or product), ignore production time UNLESS when we manage stock and quantity selected is < than quantity in stock
            if((!availableDates["product"] && !availableDates[main_variant_id]) || (selected_variant && selected_variant.inventory_management && total_quantity <= parseInt(selected_variant.inventory_quantity))){
              var shipping_main_product = this.getNextDaysAndDate(main_availableDate, main_productionTime, options);
              //Shipping time for the product
              if(!isNaN(shipping_main_product.date) && shipping_main_product.date>availableDate){availableDate = shipping_main_product.date;}
              var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
            }else{
              var shipInfo = this.getNextDaysAndDate(main_availableDate, days_nb, options);
            }
            return {"days": shipInfo.days,
                    "date": shipInfo.date,
                    "isDelayed": false};
          }
          //negative offset
          else{
            days_nb = Math.max(main_productionTime-days_nb, 1);
            var shipInfo = this.getNextDaysAndDate(availableDate<main_availableDate?main_availableDate:availableDate, days_nb, options);
            return {"days": shipInfo.days,
                    "date": shipInfo.date,
                    "isDelayed": false};
          }
        }
        // Production time is absolute value
        else{
          days_nb = parseInt(days_nb, 10);
          // Immediate shipping = 2 business days
          if (days_nb === 1) {
            days_nb++;
          }
          var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
          return {"days": shipInfo.days,
                  "date": shipInfo.date,
                  "isDelayed": false};

        }
      }
      return {"days": null,
              "date": null,
              "isDelayed": false};
    };

    /* Define Dates namespace */
  /**
    * @desc Get list of days between 2 dates
    * @param Date $startDate - Start date of the range
    * @param Date $endDate - End date of the range
    *
    * @return Array[Date] - Array containing all dates between the 2 dates
  */
  /* NOT USED
  function dateRangeToArray(startDate, endDate) {
    var datesArray = [];
    var tmpStartDate = startDate;

    while(tmpStartDate <= endDate) {
      var validDate = new Date(tmpStartDate.getTime());
      datesArray.push(validDate);
      tmpStartDate.setDate(tmpStartDate.getDate() + 1);
    }

    return datesArray;
  }*/

  // Define all functions on the Dates namespace
    ShippingDate.prototype.convert = function(date) {
        // @desc Converts the date to a date-object.
        // @param $date - The date to convert, that can be:
        //  a date object : returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //  a number      : Interpreted as number of milliseconds since 1 Jan 1970 (a timestamp)
        //  a string      : Any format supported by the javascript engine, like "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date attributes.  **NOTE** month is 0-11.
        //
        // @return Date - Date in date-Object format
        return (
            date.constructor === Date ? date :
            date.constructor === Array ? new Date(date[0],date[1],date[2]) :
            date.constructor === Number ? new Date(date) :
            date.constructor === String ? new Date(date) :
            typeof d === "object" ? new Date(date.year,date.month,date.date) :
            NaN
        );
    };

    ShippingDate.prototype.compare = function(date1,date2) {
        // @desc Compare two dates
        // @param Date $date1 - First date used for comparison (could be of any type supported by the convert function above)
        // @param Date $date2 - Second date used for comparison (could be of any type supported by the convert function above)
        //
        // @return Integer - Result based on comparison:
        //  -1 : if date1 < date2
        //   0 : if date1 = date2
        //   1 : if date1 > date2
        // NaN : if date1 or date2 is an illegal date
        return (
            isFinite(date1=this.convert(date1).valueOf()) &&
            isFinite(date2=this.convert(date2).valueOf()) ?
            (date1>date2)-(date1<date2) :
            NaN
        );
    };

    ShippingDate.prototype.inRange = function(date,startDate,endDate) {
        // @desc Checks if date is between startDate and endDate.
        // @param Date $date - Date we want to check if in between start and end dates (could be of any type supported by the convert function above)
        // @param Date $startDate - Start date of the range (could be of any type supported by the convert function above)
        // @param Date $endDate - End date of the range (could be of any type supported by the convert function above)
        //
        // @return Bool - Possible values:
        //    true  : if date is between start and end (inclusive)
        //    false : if date is before start or after end
        //    NaN   : if one or more of the dates is illegal.
       return (
            isFinite(date=this.convert(date).valueOf()) &&
            isFinite(startDate=this.convert(startDate).valueOf()) &&
            isFinite(endDate=this.convert(endDate).valueOf()) ?
            startDate <= date && date <= endDate :
            NaN
        );
    };

    ShippingDate.prototype.dateSuffix = function(date) {
        // @desc Calculates suffix of the day (st, nd, rd or th)
        // @param Date $date - Date for which to calculate day suffix (could be of any type supported by the convert function above)
        //
        // @return String - Suffix of the day (st, nd, rd or th)
        var day=this.convert(date).getDate();

        // translationJSon.javascript.delete_set_confirmation[laLang]
        if (day>3 && day<21) return translationJSon.javascript.shipping_date.date_suffix[laLang].default;
        // if (day>3 && day<21) return "th";

        switch (day % 10) {
            case 1:  return translationJSon.javascript.shipping_date.date_suffix[laLang].st;
            // case 1:  return "st";
            case 2:  return translationJSon.javascript.shipping_date.date_suffix[laLang].nd;
            // case 2:  return "nd";
            case 3:  return translationJSon.javascript.shipping_date.date_suffix[laLang].rd;
            // case 3:  return "rd";
            default: return translationJSon.javascript.shipping_date.date_suffix[laLang].default;
            // default: return "th";
        }
    };

    ShippingDate.prototype.toDaysAndWeeks = function(days_nb) {
        // @desc Transform days into weeks and remaining days (object output)
        // @param Integer $days_nb - Number of days to transform into weeks and days
        //
        // @return Object{$weeks, $days} - Returns weeks and days from initial days
        return {
          weeks : Math.floor(days_nb / 5),
          days : days_nb % 5
        };
    };

    ShippingDate.prototype.toDaysAndWeeksString = function(days_nb) {
        // @desc Transform days into weeks and remaining days (text output)
        // @param Integer $days_nb - Number of days to transform into weeks and days (text output)
        //
        // @return String - Return weeks or days string based on initial days
        var weeksAndDays = this.toDaysAndWeeks(days_nb);
        switch (weeksAndDays.weeks) {
          case 0:
            switch (weeksAndDays.days) {
              // default: return weeksAndDays.days + " days";
              default: return weeksAndDays.days + translationJSon.javascript.shipping_date.js_date_format_days[laLang];
            };
          case 1:  return "1"+translationJSon.javascript.shipping_date.js_date_format_week[laLang];
          // case 1:  return "1 week";
          default: return weeksAndDays.weeks + translationJSon.javascript.shipping_date.js_date_format_weeks[laLang];
          // default: return weeksAndDays.weeks + " weeks";
        }
    };

    ShippingDate.prototype.insertShippingDateInHTML = function(dom_id, shipping_info, mode) {
        // @desc Insert message in HTML component
        // @param String $dom_id - ID of HTML DOM element where text should be inserted
        // @param Object $shipping_info - Shipping info to insert in HTML element (object containing "days" and "date" elements)
        // @param String $mode - "days" or "date", dependending what needs to be inserted
        //
        // @return Bool - True if component exists and text was inserted, false otherwise
        var domElement = document.getElementById(dom_id);
        if (domElement) {
          switch (mode) {
            case "days":
              domElement.innerHTML = shipping_info.days ? this.toDaysAndWeeksString(shipping_info.days) : "Unavailable";
              break;
            case "date":
              // var months = '';
              var months = translationJSon.javascript.dates.month_names[laLang].january;
              if(months.indexOf('your error string') == -1){
                // months = ['january',
                //            'february',
                //            'march',
                //            'april',
                //            'may',
                //            'june',
                //            'july',
                //            'august',
                //            'september',
                //            'october',
                //            'november',
                //            'december'];
                months = [translationJSon.javascript.dates.month_names[laLang].january,
                translationJSon.javascript.dates.month_names[laLang].february,
                translationJSon.javascript.dates.month_names[laLang].march,
                translationJSon.javascript.dates.month_names[laLang].april,
                translationJSon.javascript.dates.month_names[laLang].may,
                translationJSon.javascript.dates.month_names[laLang].june,
                translationJSon.javascript.dates.month_names[laLang].july,
                translationJSon.javascript.dates.month_names[laLang].august,
                translationJSon.javascript.dates.month_names[laLang].september,
                translationJSon.javascript.dates.month_names[laLang].october,
                translationJSon.javascript.dates.month_names[laLang].november,
                translationJSon.javascript.dates.month_names[laLang].december];
              }
              else{
                months =['January','February','March','April','May','June','July','August','September','October','November','December'];
              }
              // if ('english' === 'french') {
              // if (window.location.href.indexOf("/fr") != -1) {
              if (document.querySelector("html[lang]").getAttribute("lang") == "fr") {
                domElement.innerHTML = shipping_info.date ? shipping_info.date.getDate() + " " + months[shipping_info.date.getMonth()] : "Indisponible";
              } else {
                domElement.innerHTML = shipping_info.date ? months[shipping_info.date.getMonth()] + " " + shipping_info.date.getDate() + this.dateSuffix(shipping_info.date) : "Unavailable";
              }
              break;
            case "short":
              domElement.innerHTML = shipping_info.date ? (shipping_info.date.getDate()<10? "0" :"") + shipping_info.date.getDate() + "/" + (shipping_info.date.getMonth()<9? "0" :"") + (shipping_info.date.getMonth()+1) + "/" + shipping_info.date.getFullYear() : "Variable";
              break;
            case "standard":
              domElement.innerHTML = translationJSon.javascript.shipping_date.in_stock_label_html[laLang];
              // domElement.innerHTML = 'In stock: ships within 2 working days';
              break;
          }
          return true;
        }
        return false;
    };

    ShippingDate.prototype.dateIsWeekEnd = function(date) {
        // @desc Checks if day is during week-end (Saturday/Sunday)
        // @param Date $date - Date to check (could be of any type supported by the convert function above)
        //
        // @return Bool - True if day is in week-end, else otherwise
        var day = this.convert(date).getDay();

        return ((day == 6) || (day == 0));
    };

    ShippingDate.prototype.dateIsSunday = function(date) {
      // @desc Checks if day is a Sunday
      // @param Date $date - Date to check (could be of any type supported by the convert function above)
      //
      // @return Bool - True if day is in week-end, else otherwise
      var day = this.convert(date).getDay();

      return day == 0;
  };

    ShippingDate.prototype.dateIsPublicHoliday = function(date) {
        // @TODO: need to automatically retrieve holiday list from API
        // @desc Checks if day is public holiday or not
        // @date Date $date - Day to check if public holiday or not (could be of any type supported by the convert function above)
        //
        // @return Bool - True if day is public holiday, else otherwise
        // HowToUse:  List National Holidays that are not the xth Monday of a month, including the observed day if it is a Sunday.
        var dateObject = this.convert(date);
        var sDate = (dateObject.getMonth()+1) + '/' + dateObject.getDate();
          if (sDate == '1/2' // Ganjitsu
          || sDate == '1/13' // Coming of Age Day
          || sDate == '2/11' // Kenkoku kinen no hi
          || sDate == '2/24' // Emperor anniversary (observed)
          || sDate == '3/20' // Spring Equinox
          || sDate == '4/29' // Shôwa no hi
          || sDate == '5/3' // Kenpô kinenbi
          || sDate == '5/5' // Midori no hi
          || sDate == '5/6' // Kodomo no hi
          || sDate == '7/21' // Umi no hi
          || sDate == '8/11' // Yama no hi
          || sDate == '9/15' // Shûbun no hi
          || sDate == '9/23' // Autumn Equinox
          || sDate == '10/13' // Sports Day
          || sDate == '11/3' // Bunka no hi
          || sDate == '11/24' // Kinrō Kansha no Hi
          || sDate == '11/28' // BlackFriday
          || sDate == '12/1' // BlackFriday
        ) return true; // HowToUse:  The list below contains the 4 national holidays that are the xth Monday of a month for automatic calulation.

          // HowToUse:  The list below contains the 4 national holidays that are the xth Monday of a month for automatic calulation.
          // WARNING: Because of the 2020 olympics, 2 dates were moved and are temporarily commented until 2021.
        sDate = (dateObject.getMonth()+1) + '/' + (Math.floor((dateObject.getDate() - 1) / 7) + 1) + '/' + dateObject.getDay() ;
          if ( sDate == '1/2/1' // Seijin no hi
              // || sDate == '7/3/1' // Umi no hi
              || sDate == '9/3/1' // Keirô no hi
              // || sDate == '10/2/1' // Taiiku no hi
          ) return true;

        return false;
    };

    ShippingDate.prototype.getNextDate = function(date, days_nb, options) {
        // @TODO should just re-use the getNextDaysAndDate and retrieve "date" value rather than maintaining 2 versions of same function
        //
        // @desc Calculate future date based on initial date, offset and rules (week-end, holiday...)
        // @param Date $date - Starting date (could be of any type supported by the convert function above)
        // @param Integer $days_nb - Numbers of days to add to starting date, taking into account options
        // @param Hash $options - Additional options:
        //   day_end_time (String HH) - time after which order will be processed next day (@TODO: not yet implemented)
        // skip_weekend (Bool) - Skip week-ends when calculating next day
        // skip_shopholiday (Bool) - Skip shop holidays when calculating next day
        // kip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
        //
        // @return Date - Return the future date using offset and rules
        return this.getNextDaysAndDate(date, days_nb, options).date;
    };

    ShippingDate.prototype.getNextDaysAndDate = function(date, days_nb, options) {
        // @desc Calculate number of days till future day, taking into account offset and rules (week-end, holiday...)
        // @param Date $date - Starting date (could be of any type supported by the convert function above)
        // @param Integer $days_nb - Numbers of days to add to starting date (will then take into account options to get actual number of days)
        // @param Hash $options - Additional options:
        //   day_end_time (String HH) - time after which order will be processed next day (@TODO: not yet implemented)
        // skip_weekend (Bool) - Skip week-ends when calculating next day
        // skip_shopholiday (Bool) - Skip shop holidays when calculating next day
        // kip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
        //
        // @return Hash{$days, $date} - Return number of days till future day + future date using offset and rules
        var params = $.extend(true, {
                          day_end_time       : '17',   // time in HH format (24h)
                          skip_weekend       : 'true', // true, false
                          skip_shopholiday   : 'true', // true, false
                          skip_publicholiday : 'true',// true, false
                          days               : 0
                      }, options);
        var dateObject = this.convert(date);
        var tomorrow = new Date(date);
        tomorrow.setDate(dateObject.getDate() + 1); //@TODO: should check time and not just date (cf day_end_time)
        /*var isTodaySkipped = ((params.skip_weekend && this.dateIsWeekEnd(dateObject)) ||
                (params.skip_shopholiday && dateIsShopHoliday(dateObject)) ||
                (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject)));*/

        if (params.skip_shopholiday && this.dateIsShopHoliday(dateObject)) {
          return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {days: (params.days+1)}));
        }
        else if (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject) && params.skip_weekend && this.dateIsSunday(dateObject)){
          return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {days: (params.days+1)}));
        }
        else if (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject)){
          return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {days: (params.days+1)}));
        }
        else if (params.skip_weekend && this.dateIsWeekEnd(dateObject)) {
          return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {days: (params.days)}));
        }
        else {
          if (days_nb > 0) {
            return this.getNextDaysAndDate(tomorrow, days_nb - 1, $.extend(true, options, {days: (params.days+1)}));
          }
          else {
            return {"days": params.days,
                    "date": dateObject};
          }
        }
    };

  module.exports = ShippingDate;

  },{}],9:[function(require,module,exports){
  /*
    Note: the showing and hiding of the tabs is done entirely by the ShowHide module inside the core.
    This module just deals with adding a callback to make sure the tab actions have the correct active classes.
  */

  var _ = require('./_lib.js');

  var TabActions = function () {
    this.actionAttr = 'data-tab-action';
    this.actionEls = document.querySelectorAll('['+this.actionAttr+']');

    // Make sure that the Seido core is ready so that we can do what we need when ShowHide sends it's show event.
    _.readyCore(function () {
      this._addEventListeners();
    }, this);
  };

  TabActions.prototype.setActiveClass = function (currentActionEle) {
    // Remove active classes
    _.each(this.actionEls, function (actionEl) {
      actionEl.classList.remove('is-active');
    });

    // Add active class to current tab
    currentActionEle.classList.add('is-active');
  };

  // Private
  TabActions.prototype._addEventListeners = function () {
    var _this = this;
    window.SeidoCore.display.on('show', function (currentActionEle) {
      if (currentActionEle.hasAttribute(_this.actionAttr)) {
        _this.setActiveClass(currentActionEle);
      }
    });
  }

  module.exports = TabActions;
  },{"./_lib.js":3}],10:[function(require,module,exports){
  var _ = require('./_lib.js');

  var WordValidator = function () {
    this.Validators = {};
    this.specialWords = ["武道","武道家","武産","合氣","合気","合氣道家","合気道家","合気道","合氣道","合 気 道","合 氣 道","合気武道","合氣武道","岩間流","合気会","合氣会","柔道家","柔道","剣道","剣術","空手","空手道","居合道","居合術","道場","武士道","養神館","日本","日本人","拳法","日本柔術","体術","稽古","無心","ドイツ","フランス","アメリカ","スペイン","ロシア","オストラリア","イギリス","イタリア","カナダ","ブラジル","スイス","自然流","自然道","自然","鹿島","神伝","直心影","直心影流","香取","神道流","神道 流","夢想流","夢想 流","杖術","杖 術","杖道","杖 道","正勝","吾勝","勝早日","七転","八起","七転び","八起き","budo","bu do","takemusu","take musu","aiki","aikido","aikido","ai ki do","aikidoka","iwamaryu","iwama-ryu","iwama ryu","aikikai","ai ki kai","judo","ju do","judoka","ju do ka","karate","karatedo","kara te do","iai","i ai","iaido","i ai do","dojo","bushido","bu shi do","yoshinkan","yo shin kan","nihon","nihon","nippon","kempo","kem po","ken po","jujutsu","ju jutsu","jujitsu","ju jitsu","keiko","kei ko","mushin","mu shin","germany","france","america","united states","spain","russia","australia","united kingdom","italy","canada","brazil","switzerland","kashima","shinden","jiki","shinkage","shinkageryu","shinkage ryu","katori","shinto","shintoryu","shinto ryu","muso","musoryu","muso ryu","jodo","jo do","jojutsu","jo jutsu","masakatsu","agatsu","katsu hayabi","nanakorobi","yaoki","nana korobi","ya oki"];
    this.specialWords.sort(function(a, b){return b.length - a.length;});
    this.instructionsWords = ["please","embroidery","embroideries","engraving","engravings","size","(",")"]
    this.init();
    this._addEventListeners();
    // 'Please enter the embroidery/engraving content only. No special character, no dot, comma, etc.\
    // Use the "Additional comment" box for additional explanations.'
  };


  WordValidator.prototype.init = function () {
    var _this = this;
    var services = document.getElementsByClassName('product-variants');
    _.each(services, function(service){
      var validationSelector = service.querySelector('[data-validation-selector]');
      var validationInput = service.querySelector('[data-validation-input]');
      if(validationSelector && validationInput){
        validationSelector.dataset.validationType = validationInput.dataset.validationType;
        this.Validators[validationSelector.dataset.validationSelector] = {selector:validationSelector,
                                                  input: validationInput,
                                                  method: validationInput.dataset.validationMethod,
                                                  message: service.querySelector('[data-validation-msg]'),
                                                  special_words: service.querySelector('[data-validation-words]'),
                                                  file: service.querySelector('[type="file"]')};
      }
    },this);
  };

  WordValidator.prototype._addEventListeners = function () {
    var _this = this;
    var serviceWrapper = document.querySelector('[id^="service-"]');
    if (serviceWrapper){
      serviceWrapper.addEventListener('change', function(e){
        var validatorId = e.target.dataset.validationInput || e.target.dataset.validationSelector;
        if (_this.Validators[validatorId]){
          _this.validateContent(_this.Validators[validatorId]);
        }
      });
    }
  };

  WordValidator.prototype.validateContent = function(validator){
    if(validator.file.value != ""){ // If image uploaded
      this.updateStateValidator(validator, true);
    }
    else{
      var content_data = {length:-1};
      if(validator.method == "letter-count"){
        content_data.length = this.letterCount(validator.input);
      }
      else if(validator.method == "word-count"){
        content_data = this.wordCount(validator.input);
      }
      if( content_data.length == -1){ // Count method undefined
        this.updateStateValidator(validator, false);
      }
      else{
        var sizeSelected = validator.selector.options[validator.selector.selectedIndex].value.match(/(\d)+/);
        if(sizeSelected){ // Length selected
          this.updateStateValidator(validator, (sizeSelected[0]>=content_data.length), content_data.specialWords);
        }
        else if(validator.input.value == ''){ // Length not selected but input empty
          this.updateStateValidator(validator, true);
        }
        else{ // Length not selected and input not empty
          this.updateStateValidator(validator, false, content_data.specialWords);
        }
      }
    }
  };

  WordValidator.prototype.wordCount = function(input){
    var content = this.filterSpecialWords(input.value);
    var length = this.filterLongWords(content.input);
    return {length:length, specialWords:content.specialWords};
  };

  WordValidator.prototype.filterSpecialWords = function (input) { // Look for special words
    var specialWordsFounded = []; // Array of words founded
    if (this.specialWords.length > 0) {
      for (var s in this.specialWords) {
        if ((this.specialWords[s].indexOf(" ") != -1) && (input.toLowerCase().indexOf(this.specialWords[s]) > -1)) {
          specialWordsFounded.push(this.specialWords[s]);
          input = input.toLowerCase().replace(new RegExp(this.specialWords[s],"g"), this.specialWords[s].replace(/ /g,''));
        }
      }
    }
    return {input:input, specialWords:specialWordsFounded} // return the string after deleting special words and the list of words founded
  };

  WordValidator.prototype.filterLongWords = function (input) {
    var input_arr = input.split(/ |-|,|\.|&|\u3000|\u30FB/);
    var nb_words = 0;
    for (var i=0; i<input_arr.length; i++) {
      nb_words += Math.ceil(input_arr[i].length/10);
    }
    return nb_words;
  };

  WordValidator.prototype.letterCount = function(input){
    return input.value.replace(/ |\u3000/g, '').length;  // The only separators are " " and "japanese space"
  };

  WordValidator.prototype.updateStateValidator = function(validator, isValid, specialWords){
    validator.selector.dataset.validationValid = isValid;
    validator.input.dataset.validationValid = isValid;
    if(isValid){validator.message.classList.add("display_none")}
    else{validator.message.classList.remove("display_none")}

    if(false){
      if(this.findInstruction(validator.input)){validator.instruction.classList.remove("display_none");}
      else{validator.instruction.classList.add("display_none");}
    }
    if(specialWords && specialWords.length){
      validator.special_words.classList.remove("display_none");
      validator.special_words.querySelector('span.words').innerHTML = specialWords.join(',');
    }
    else if(specialWords){
        validator.special_words.classList.add("display_none")
    }
  };

  WordValidator.prototype.findInstruction = function(input){
    for (var s in this.instructionsWords) {
      if (input.toLowerCase().indexOf(this.instructionsWords[s]) > -1) {
        return true;
      }
    }
    return false;
  };


  module.exports = WordValidator;
  },{"./_lib.js":3}],11:[function(require,module,exports){
  var _ = require('./_lib.js');
  var Tabs = require('./_tabs.js');
  var ProductBuilder = require('./_product-selectors.js');
  var Eventer = require('./_eventer.js');
  var WordValidator = require('./_word-validator.js');
  var Nav =  require('./_product-nav.js');
  var Product = function () {
   // Trigger a ready even when the core has finished loading
    new Eventer(this);
    var _this = this;
    _.ready(function () {
      new ProductBuilder();
      _this.triggerReady();
      new Tabs();
      _this.wordValidator = new WordValidator();
      new Nav();
      //on traduit que si pas en anglais, la langue du shop
      // if(document.querySelector("html[data-locale]").getAttribute("data-locale") != "en"){
        _this.translateReview();
      // }
    });

  };

  Product.prototype.translateProductNameJsonReview = function () {
    if(document.querySelector("#shopify-product-reviews > script")){
      //get the json
      var product_review_json = JSON.parse(document.querySelector("#shopify-product-reviews > script").innerHTML);
      //change the json value with a translated name in another json
      product_review_json.itemReviewed.name = JSON.parse(document.querySelector("#backtop > script").innerHTML)["name"];
      //insert the json in the html
      document.querySelector("#shopify-product-reviews > script").innerHTML = JSON.stringify(product_review_json)
    }
  }


  Product.prototype.translateReview = function () {
    //timeout pour charger après shopify, voir si possibilité d'optimiser
    var _this = this;
    var t = setInterval(function() {
      if(document.querySelector(".spr-button.spr-button-primary.button.button-primary.btn.btn-primary")){
        clearInterval(t);
        //change la langue du formulaire des review
        //------------titre du formulaire ---------
        document.querySelector(".spr-header-title").innerHTML = translationJSon.javascript.reviews.spr_header_title[laLang];
        //------------ Base sur xxx review ---------
        //recupere le span du nombre
        if(document.querySelector('.spr-summary-actions-togglereviews')){
        //var spanNbRev = document.querySelector('.spr-summary-actions-togglereviews').firstElementChild;
        //--------get the number of reviews from the span--------
        var spanNbRev = document.querySelector('.spr-summary-actions-togglereviews').innerHTML;
        var numberReview = spanNbRev.match(/\d+/)[0];
        var txtNbRev = translationJSon.javascript.reviews.spr_summary_actions_togglereviews[laLang];
        var txtNbRevSplit = txtNbRev.split("%js_reviews_count%");
        document.querySelector('.spr-summary-actions-togglereviews').innerHTML = txtNbRevSplit[0] + numberReview + txtNbRevSplit[1];
        }else{// pas de review, mais on traduit "no review yet"
          document.querySelector('.spr-summary-caption').innerHTML = translationJSon.javascript.reviews.no_reviews[laLang]
        }
        //------------ Bouton formulaire  ---------
        document.querySelector(".spr-summary-actions-newreview").innerHTML = translationJSon.javascript.reviews.spr_summary_actions_newreview[laLang];
        //------------ Titre formulaire  ---------
        document.querySelector(".spr-form-title").innerHTML = translationJSon.javascript.reviews.spr_form_title[laLang];
        //------------ Partie nom (titre, placeholder et after)  ---------
        //Title
        document.querySelector(".spr-form-contact-name .spr-form-label").innerHTML = translationJSon.javascript.reviews.spr_form_contact_name.spr_form_label[laLang];
        //placeholder
        document.querySelector(".spr-form-contact-name .spr-form-input-text").placeholder = translationJSon.javascript.reviews.spr_form_contact_name.spr_form_input_text[laLang];
        //after
        var elN = document.createElement("span")
        elN.className = "spr-form-disclaimer";
        elN.innerHTML = translationJSon.javascript.reviews.spr_form_contact_name.after[laLang];
        document.querySelector(".spr-form-contact-name").append(elN);
        //------------ Partie Email (titre, placeholder et after)  ---------
        //Title
        document.querySelector(".spr-form-contact-email .spr-form-label").innerHTML = translationJSon.javascript.reviews.spr_form_contact_email.spr_form_label[laLang];
        //placeholder
        document.querySelector(".spr-form-contact-email .spr-form-input-email").placeholder = translationJSon.javascript.reviews.spr_form_contact_email.spr_form_input_email[laLang];
        //after
        var elM = document.createElement("span")
        elM.className = "spr-form-disclaimer";
        elM.innerHTML = translationJSon.javascript.reviews.spr_form_contact_email.after[laLang];
        document.querySelector(".spr-form-contact-email").append(elM);
        //------------ Partie Location (titre, placeholder et after)  ---------
        //Title
        document.querySelector(".spr-form-contact-location .spr-form-label").innerHTML = translationJSon.javascript.reviews.spr_form_contact_location.spr_form_label[laLang];
        //placeholder
        document.querySelector(".spr-form-contact-location .spr-form-input-text").placeholder = translationJSon.javascript.reviews.spr_form_contact_location.spr_form_input_text[laLang];
        //after
        var elL = document.createElement("span")
        elL.className = "spr-form-disclaimer";
        elL.innerHTML = translationJSon.javascript.reviews.spr_form_contact_location.after[laLang];
        document.querySelector(".spr-form-contact-location").append(elL);
        //------------ Partie Rating  ---------
        document.querySelector(".spr-form-review .spr-form-label").innerHTML = translationJSon.javascript.reviews.spr_form_review_rating.spr_form_label[laLang];
        //------------ Partie Review Title  ---------
        //Title
        document.querySelector(".spr-form-review-title .spr-form-label").innerHTML = translationJSon.javascript.reviews.spr_form_review_title.spr_form_label[laLang];
        //placeholder
        document.querySelector(".spr-form-review-title .spr-form-input-text").placeholder = translationJSon.javascript.reviews.spr_form_review_title.spr_form_input_text[laLang];
        //------------ Partie Body Review  ---------
        //Title
        var spanBodyRev = document.querySelector('.spr-form-review-body .spr-form-label').firstElementChild;
        document.querySelector('.spr-form-review-body .spr-form-label').innerHTML = translationJSon.javascript.reviews.spr_form_review_body.spr_form_label[laLang] + spanBodyRev.outerHTML;
        //placeholder
        document.querySelector(".spr-form-review-body .spr-form-input-textarea").placeholder = translationJSon.javascript.reviews.spr_form_review_body.spr_form_input[laLang];
        //------------ Partie Bounton Send  ---------
        document.querySelector(".spr-form-actions .spr-button").value = translationJSon.javascript.reviews.spr_form_actions[laLang];
        //------------ Boutons Next et previous  ---------
        if(document.querySelector(".spr-pagination-next")){
          document.querySelector(".spr-pagination-next a").innerHTML = translationJSon.javascript.reviews.spr_pagination_next[laLang];
          document.querySelector(".spr-pagination-next").addEventListener("click", function(){
            reviewNextPrev();
          });
        }
        reviewDates();
      }

      _this.translateProductNameJsonReview();

    }, 100);
  }

  //called inside translateReview, translate the Next and Previous button - take into account when we click on them too
  function reviewNextPrev() {
    setTimeout(function() {
      reviewDates();
      if(document.querySelector(".spr-pagination-next")){
        document.querySelector(".spr-pagination-next a").innerHTML = translationJSon.javascript.reviews.spr_pagination_next[laLang];
        document.querySelector(".spr-pagination-next").addEventListener("click", function(){
          reviewNextPrev();
        });
      }
      if(document.querySelector(".spr-pagination-prev")){
        document.querySelector(".spr-pagination-prev a").innerHTML = translationJSon.javascript.reviews.spr_pagination_prev[laLang];
        document.querySelector(".spr-pagination-prev").addEventListener("click", function(){
          reviewNextPrev();
        });
      }
    }, 300);
  }

  //change the review header depending on the chosen language
  function reviewDates(){
      //------------ Reviews date  ---------
      // if (at least) a review exist
      if(document.querySelector(".spr-reviews .spr-review")){
        // var datesUS = document.querySelectorAll(".spr-reviews .spr-review strong~strong");
        var datesUS = document.querySelectorAll(".spr-review .spr-review-header-byline span[data-created_at]");

        for(var i=0; i<datesUS.length;i++){
          var aDate = datesUS[i].innerHTML;
          var aDate = datesUS[i].getAttribute("data-created_at");
          var dateSplit = aDate.split(" ");

          //get the months of the language in json
          var monthsLang = translationJSon.javascript.dates.abbr_month_names[laLang];
          //get all the key from the json we got above
          var key = Object.keys(monthsLang);
          //find the key depending on the string we got
          var keyFind = key.find(function(element){ return element.indexOf(dateSplit[0].toLowerCase()) != -1});

          var monthToPrint = translationJSon.javascript.dates.month_numbers[keyFind];

          //get the name of the customer who posted the review
          var author;
          var location;
          if(document.querySelectorAll(".spr-review-header-byline span")[i]){
            author = document.querySelectorAll(".spr-review-header-byline span")[i].getAttribute("data-author");
            location = document.querySelectorAll(".spr-review-header-byline span")[i].getAttribute("data-location");
          }
          else{
            author = "";
            location="";
          }

          // var dateCreated = document.querySelectorAll(".spr-review-header-byline span")[i].getAttribute("data-created_at");

          var commentHead = translationJSon.javascript.reviews.comments_headline[laLang];
          //<span data-author="" data-location="" data-created_at=""></span>
          var spanData = $(".spr-review-header-byline")[i].firstChild;

          if(document.querySelector("html[data-locale]").getAttribute("data-locale") == "fr"){
            //fail safe if author = null
            if(author){
              commentHead = commentHead.replace("xxx",author);
            }else{
              commentHead = commentHead.replace("xxx","");
            }
            commentHead = commentHead.replace("dd",dateSplit[1].replace(",",""));
            if(location){
              commentHead = commentHead.replace("place",location);
            }else{
              commentHead = commentHead.replace(" de <b>place</b>","");
            }
            commentHead = commentHead.replace("mm",monthToPrint);
            commentHead = commentHead.replace("yyyy",dateSplit[2]);
            document.querySelectorAll(".spr-review-header-byline")[i].innerHTML = spanData.outerHTML + commentHead;
            // $(".spr-review-header-byline")[i].append(commentHead);
            // $(".spr-review-header-byline")[i].innerText = commentHead;
          }
          else if (document.querySelector("html[data-locale]").getAttribute("data-locale") == "ja"){
            if(author){
              commentHead = commentHead.replace("xxx",author);
            }else{
              commentHead = commentHead.replace("xxx","");
            }
            // commentHead = commentHead.replace("xxx",author);
            if(location){
              commentHead = commentHead.replace("place",location);
            }else{
              commentHead = commentHead.replace("place","");
            }
            // commentHead = commentHead.replace("place",location);
            commentHead = commentHead.replace("dd",dateSplit[1].replace(",",""));
            commentHead = commentHead.replace("mm",monthToPrint);
            commentHead = commentHead.replace("yyyy",dateSplit[2]);
            document.querySelectorAll(".spr-review-header-byline")[i].innerHTML = spanData.outerHTML + commentHead;
            // $(".spr-review-header-byline")[i].innerText = commentHead;
            // $(commentHead).insertAfter($(".spr-review-header-byline")[i]);
          }
          //so en
          else{
            if(author){
              commentHead = commentHead.replace("xxx",author);
            }else{
              commentHead = commentHead.replace("xxx","");
            }
            if(location){
              commentHead = commentHead.replace("place",location);
            }else{
              commentHead = commentHead.replace(" from <b>place</b>","");
            }
            commentHead = commentHead.replace("dd",dateSplit[1].replace(",",""));
            commentHead = commentHead.replace("mm",dateSplit[0]);
            commentHead = commentHead.replace("yyyy",dateSplit[2]);
            document.querySelectorAll(".spr-review-header-byline")[i].innerHTML = spanData.outerHTML + commentHead;
          }

        }
      }
  }




  Product.prototype.triggerReady = function () {
    // Let anyone that is listening for the core know that it's now ready.
    this.ready = true;
    this.trigger('ready');
  };

  window.ProductCore = new Product();
  },{"./_eventer.js":2,"./_lib.js":3,"./_product-nav.js":5,"./_product-selectors.js":7,"./_tabs.js":9,"./_word-validator.js":10}]},{},[11])

});// fin ajax
